/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Observable } from 'rxjs';
import { finalize, catchError, map } from 'rxjs/operators';


import { NgxSpinnerService } from 'ngx-spinner';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzSelectItemInterface } from 'ng-zorro-antd/select';

import { CompaniesTestLinkComponent } from '../../companies/modals';
import { AppConfig } from '../../../core/configs';
import {
  CompanyInterface,
  PartnerInterfaceGlobal,
  PlatformInterface,
  SelectItemsInterface
} from '../../../core/models';
import { HelpersInterface, KeyValueType } from '../../../core/interfaces';
import {
  checkboxesForUpdateDSPForm,
  jsDSPCheckboxes,
  preBidDSPCheckboxes,
  removedJsDSPFields,
  removedPreBidDSPFields,
  removedRtbDSPFields,
  removedVastDSPFields,
  rtbDSPCheckboxes,
  schainStatusItems,
  vastDSPCheckboxes
} from '../../../core/constants';
import { RtbConnectionMode, UserRole } from '../../../core/enum';
import {
  AppOptionsService,
  AuthService,
  DynamicFormService,
  ErrorsHandlingService,
  NotificationService,
  ViewerRestrictionService
} from '../../../core/services';
import {
  getEndpointsCheckedKeys,
  rearrangeFilterListItems,
  updateCheckedStatus,
  rearrangeCompaniesItems,
  getStringCheckedKeys,
  transformArray
} from '../../../core/helpers';
import { ErrorValidator } from '../../../core/validators';
import { DeleteEndpointConfirmComponent, NotificationComponent } from '../../../shared/components';

import { GeneralSchainService } from '../../source-schain/services';
import { SourceSchainInterface } from '../../source-schain/models';


import {
  MainDashboardInterface,
  auctionTypesItems,
  connectionTypesNamesDSP,
  endpointValidationStatusItems,
  macrosListJsDSP,
  defaultMacrosListVast,
  marginKeys,
  nativeVersionsItems,
  playerSizesItems,
  apiLinkValidationStatus,
} from '../models';
import { MainService } from './main.service';
import { BlockAllowEndpointsDialogComponent, ConsentConfirmComponent } from '../modals';
import { MacrosListComponent } from '../components';

@Injectable({
  providedIn: 'root'
})
export class EditDspService {
  public editDSPForm: FormGroup;
  public tabIndex = 0;
  public apiLink = '';
  public userRole: UserRole;
  public nativeSpec = 1;

  public endpointUrl = '';

  public adapterConfigFields: KeyValueType[];
  public isRequiredAdFormat = false;
  public isRequiredTrafficType = false;
  public isRequiredCompany = false;
  public isRequiredRegion = false;
  public isShowFields = false;
  public isFreewheelKeywordsEnabled = false;
  public freewheelKeywordsData = {
    timezone: '',
    city: '',
    dma: '',
    state: '',
    programmer_brand: '',
    channel: '',
    genre: '',
    language: '',
    content_rating: '',
    content_stream_mode: '',
  };

  public readonly FREEWHEEL_KV_MAX_PAIRS = 5;
  public freewheelKeyValuePairs: Array<{ key: string; value: string }> = [{ key: '', value: '' }];

  public isDisabledTest = false;
  public isDisableSubmit = false;
  public isDisableDuplicate = false;

  public isShowVideoSizes = true;
  public isShowBannerSizes = true;

  public connectionTypesNamesDSP = connectionTypesNamesDSP;
  public RtbConnectionMode = RtbConnectionMode;

  public preBidItem: PlatformInterface.IPreBidItem;
  public adaptersItem: PlatformInterface.IRtbAdaptersItem;
  public partnerSettings: PartnerInterfaceGlobal.IPartnerSettings;

  public sourceSchainItems: SourceSchainInterface.ISourceSchain[] = [];

  public filterLists: HelpersInterface.IFilterListsItems[] = [];
  public schainValues: SelectItemsInterface.ISchainValue[] = [];
  public schainNodeOrderItems: SelectItemsInterface.ISchainNodeOrder[] = [];
  public schainNodesFilters: { id: number; name: string }[] = [];
  public schaninNodeLimitItems: { id: number; name: string }[] = [];
  public schainStatusItems = schainStatusItems;
  public rtbVersions: { id: string; name: string }[] = [];
  public regions: { id: string, name: string }[] = [];
  public companies: CompanyInterface.ICompany[] = [];
  public listOfSizes: { id: number, width: number | null, height: number | null, name: string }[] = [];
  public serversPreBid: { id: number | string; name: string, config }[] = [];
  public rtbAdapters: { id: number | string; name: string, config }[] = [];
  public secureOptions: { id: number, name: string }[] = [];
  public pornFilter: { id: number, name: string }[] = [];
  public sspList: PlatformInterface.IPlatformSSP[] = [];
  public sizesList: { id: string | number, name: string }[] = [];
  public videoSizesList: { id: string | number, name: string }[] = [];
  public statesList: HelpersInterface.SelectItemHelper<string, string>[] = [];
  public osList: { id: string | number, name: string }[] = [];
  public connectionTypes: { id: number, name: string }[] = [];
  public adaptersRtb: any[] = [];
  public serverPreBid: any[] = [];
  public nurlOptions: any[] = [];

  public vastTemplate = '';

  public separator: string;

  public nativeVersions = nativeVersionsItems;

  public auctionTypes = auctionTypesItems;

  public apiLinkValidationStatus = apiLinkValidationStatus;
  public endpointValidationStatus = endpointValidationStatusItems;

  public playerSizes = playerSizesItems;
  public countriesItems: SelectItemsInterface.ICountriesItem[] = [];

  public allowCountriesTrigger = [{ id: 0, name: 'Block' }, { id: 1, name: 'Allow' }];

  public coppaFilterItems = [
    { id: 0, name: 'Only coppa=0' },
    { id: 1, name: 'Only coppa=1' },
  ];

  public lmtAndDntFilterItems: HelpersInterface.SelectItemHelper<number, string>[] = [
    { id: 0, name: 'Exclude All' },
    { id: 1, name: 'Exclude LMT=1' },
    { id: 2, name: 'Exclude DNT=1' },
  ];

  private endpointId: number;

  private partner: PartnerInterfaceGlobal.IPartnerGeneral;
  private requiredFields = {
    endpoint: 'Endpoint',
    companyId: 'Company',
    totalSpendLimit: '',
  };

  private sspFileCnt = 0;
  private dspFileCnt = 0;

  private isDisabledRubiconOption = false;

  private listOfMacros: MainDashboardInterface.IVastMacros[] = [];

  private marginKeys = marginKeys;
  private arrayOfMargins: { key: string, minValue: number, maxValue: number }[] = [];
  private activeIntervals: any[] = [];
  private adServers: any[] = [];
  private macrosListJs = macrosListJsDSP;
  private macrosListVast = defaultMacrosListVast;
  private preBidFields: { field: string | number, id: string, config, tooltip?: string }[] = [];
  private rtbServers: PlatformInterface.IRtbAdaptersItem[] = [];
  private adaptersFields: { field: string | number, id: string, config }[] = [];
  private fieldsAdapters: any[] = [];
  private value;
  private adapter_id: string | number;
  private preBidServers: PlatformInterface.IPreBidItem[] = [];

  private _companiesSSPDropdown: HelpersInterface.ITressSelectItem[] = [];
  private _isShowCustomSchain = false;
  private _isShowCustomSchainFilters = false;
  private _isShowSchainNodeOrder = false;
  private _isShowSourceFile = false;


  private get servers() {
    return this._servers;
  }

  private set servers(value) {
    this._servers = value;
  }

  private _servers: any[] = [];

  private apiUrl: string;

  constructor(
    public options: AppOptionsService,
    public auth: AuthService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    private notificationComponent: NotificationComponent,
    private loadingService: NgxSpinnerService,
    private dynamicFormService: DynamicFormService,
    private mainService: MainService,
    private errorsHandlingService: ErrorsHandlingService,
    private viewerRestrictionService: ViewerRestrictionService,
    private appConfig: AppConfig,
    private sourceSchainService: GeneralSchainService,
    private http: HttpClient,
  ) {
    this.apiUrl = this.options.getApiUrl();
  }

  public initComponent(data: MainDashboardInterface.IEditDSPDialog) {
    this.createForm();
    this.fetchInitialData(data);
    this.initializeData(data);
    this.initPartnerSettings(data);
    this.initializePartnerSpecificSizes();
  }

  public get isDisabledSubmitBtn(): boolean {
    return this.isDisableSubmit || this.isUserViewer;
  }

  public set isShowSchainNodeOrder(value: boolean) {
    this._isShowSchainNodeOrder = value;
  }

  public get isShowSchainNodeOrder(): boolean {
    return this._isShowSchainNodeOrder;
  }

  public restrictionTooltipMessageForButton(connectionType: number): string {
    const restrictedConnectionTypes = [4, 5];
    return this.partner?.partner_plan === 3 && restrictedConnectionTypes.includes(connectionType) ? `The endpoint is not available for editing because your current plan no longer supports the connection type of this endpoint.
       If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public restrictionTooltipMessageForEnterprise(schainType: string): string {
    return this.partner.partner_plan !== 1 ? `${schainType} is available on Enterprise version.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public restrictionTooltipMessage(field: string): string {
    return (this.partner?.partner_plan !== 1 && this.partner?.partner_plan !== 2) ? `${field} is available on Plus and Enterprise versions.
    If you want to upgrade your platform, please contact our Business Development Manager` : '';
  }

  public isBotmanPostBidIsEnabled() {
    return !!this.auth.partner.botman_settings?.enable_postbid;
  }

  public isHumanFraudsensorEnabled(): boolean {
    return !!this.partnerSettings.use_fraud_sensor;
  }

  public isFraudLogixEnabled(): boolean {
    return !!this.partnerSettings.useFraudlogix;
  }

  public get sChainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Domain" field in Sellers.Json section'
      : 'Enabling this option activates platform processing of the schain nodes according to the Sellers.json settings.';
  }

  public get SSPSourceSchainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Contact Domain" field in Default Sellers.Json settings in the Frameworks and Regulation section'
      : `Applies Source Schain matching based on the SSP company sending the request. Only one type of Source Schain can be active at a time.
      Before activating, we recommend setting up a direct allow list with SSP endpoints linked to your file
      and applying a filter list that only allows sources included in your uploaded file`;
  }

  public get DSPSourceSchainToolTipText(): string {
    return !this.partnerSettings.sellersJson.contact_domain
      ? 'Please fill the "Contact Domain" field in Default Sellers.Json settings in the Frameworks and Regulation section'
      : `Applies Source Schain matching based on the file you select in the dropdown menu.
      Before activating, we recommend applying a filter list that only allows the sources included in your uploaded file.`;
  }

  public get videoSizeControl(): FormControl {
    return this.editDSPForm.get('playerSizes')?.get('size') as FormControl;
  }

  public get presetVideoSizeControl(): FormControl {
    return this.editDSPForm.get('presetPlayerSizes')?.get('size') as FormControl;
  }

  public openLink(): void {
    window.open('https://smart-hub-io.atlassian.net/wiki/spaces/KBS/pages/652214275/Dual+Schain+Object+processing', '_blank');
  }

  public get formValue() {
    return this.editDSPForm.getRawValue();
  }

  public get isUserViewer(): boolean {
    return this.userRole === UserRole.viewer;
  }

  public get pixalatePBSettingsControls(): { [key: string]: FormControl } {
    return (this.editDSPForm.get('pixalate_pb_settings') as FormGroup).controls as { [key: string]: FormControl };
  }

  public get nativeSpecControl(): FormControl {
    return this.editDSPForm.get('nativeSpec') as FormControl;
  }

  public set isShowCustomSchain(value: boolean) {
    this._isShowCustomSchain = value;
  }

  public get isShowCustomSchain(): boolean {
    return this._isShowCustomSchain;
  }

  public set isShowCustomSchainFilters(value: boolean) {
    this._isShowCustomSchainFilters = value;
  }

  public get isShowCustomSchainFilters(): boolean {
    return this._isShowCustomSchainFilters;
  }

  public set isShowSourceFile(value: boolean) {
    this._isShowSourceFile = value;
  }

  public get isShowSourceFile(): boolean {
    return this._isShowSourceFile;
  }

  public set companiesSSPDropdown(value: HelpersInterface.ITressSelectItem[]) {
    this._companiesSSPDropdown = value;
  }

  public isShowStatesControl(): boolean {
    const countries: string[] = this.formValue?.countriesList ?? [];
    return ['USA', 'NA'].some(code => countries.includes(code));
  }

  public isShowVastAdditionalSettings(): boolean {
    return ((this.isVastConnection() && this.formValue.adtype === 'inApp') || (this.isJSConnection() && this.formValue.jsAdType === 'inApp'));
  }

  public isShowRtbAdditionalSettings(): boolean {
    return (this.isRtbConnection() || this.isPreBidConnection());
  }

  public filterStatesList(query: string, option: NzSelectItemInterface) {
    if (option.nzLabel && typeof option.nzLabel === 'string') {
      if (option.nzLabel?.toLowerCase().startsWith(query.toLowerCase())) {
        return option.nzLabel?.toLowerCase().startsWith(query.toLowerCase());
      } else {
        return option.nzValue?.toLowerCase().includes(query.toLowerCase());
      }
    }

    return false;
  }

  public get companiesSSPDropdown(): HelpersInterface.ITressSelectItem[] {
    return this._companiesSSPDropdown;
  }

  public onChangeVideoFormatHandler(value: boolean): void {
    if (this.isVastConnection()) {
      this.onChangeVastMacrosesByFormat(value);
    }

    this.updateSizesVisibility({ video: value });
  }

  public onChangeBannerFormatHandler(value: boolean): void {
    this.updateSizesVisibility({ banner: value });
  }

  public onChangeRewardedVideoFormatHandler(value: boolean): void {
    this.onChangeVastMacrosesByFormat(value);

    this.updateSizesVisibility({ rewarded: value });
  }

  public onChangeNativeHandler(value: boolean): void {
    if (value) {
      const currentValue = this.formValue.nativeSpec;
      if (!currentValue || currentValue.length === 0) {
        this.formControls['nativeSpec'].patchValue([-1]);
      }
    } else {
      this.formControls['nativeSpec'].patchValue([]);
    }

    this.updateSizesVisibility({ native: value });
  }

  public onChangeOnlyWithIFAHandler(value: boolean): void {
    if (!value) {
      this.formControls['allow_synth_ifa'].patchValue(false, { emitEvent: false });
    }

    this.updateDeviceIdAndLmtDntFilterState();
  }


  public onChangeIsLmtAndDntFilterHandler(): void {
    this.updateDeviceIdAndLmtDntFilterState();
  }

  public onChangeLMTAndDNTFilterHandler(value: boolean): void {
    if (!value) {
      this.formControls['lmt_and_dnt_filter']?.patchValue(0, { emitEvent: false });
    }

    this.updateDeviceIdAndLmtDntFilterState();
  }

  public onChangePixalatePreBidIpHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ip_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidIFAHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('ifa_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangePixalatePreBidBundleHandler(value: any): void {
    if (!value) {
      this.formControls['pixalate_pb_settings']?.get('hr_app_percent')?.patchValue(0, { emitEvent: false });
    }
  }

  public onChangeSSPSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });

    } else if (!value && !this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    } else if (!value && this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }



    if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangePlatformSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchain = value;
    this.isShowCustomSchainFilters = value;

    if (value) {
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }


    if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    if (!value) {
      this.isShowSchainNodeOrder = false;
      this.formControls['schain_node_order'].patchValue(1, { emitEvent: false });
      this.formControls['schainCompany'].patchValue(1, { emitEvent: false });
    }

    this.updateFormControlsBasedOnPartnerPlan();

    if (!this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    this.updatePchainFormControl();

    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeDSPSourceSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    this.isShowSourceFile = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
      this.getSourceSchainItems('dsp');
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });

      this.formControls['ipd_only'].patchValue(false, { emitEvent: false });

      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['dsp_schain_source_file_id'].patchValue(0, { emitEvent: false });
      this.sourceSchainItems = [];
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }


    if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    if (!this.partnerSettings.sellersJson.contact_domain) {
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeSSPSourceSchainStatusHandler(value: boolean): void {
    this.isShowCustomSchainFilters = value;
    if (value) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
      this.formControls['dsp_schain_source_file_id'].patchValue(0, { emitEvent: false });
    } else {
      this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].enable({ emitEvent: false });
      this.formControls['isSspSchain'].enable({ emitEvent: false });
      this.formControls['schain_source'].enable({ emitEvent: false });
      this.formControls['is_schain_complete'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
    }

    if (this.sspFileCnt === 0) {
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.dspFileCnt === 0) {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }


    if (this.formValue.selectedAdapters !== 0) {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.updatePchainFormControl();
    this.updateIsAuthorizedSchainControlState();
  }

  public onChangeSchainCompanyHandler(value: number): void {

    if (value === null) {
      return;
    }

    this.isShowSchainNodeOrder = this.formValue.schainCompany && value !== 1;
    this.updateSchainNodeOrderItems(value);
  }

  public onChangeSchainNodeOrderHandler(value: number, modalWidth: string): void {
    const origin = window.location.origin;
    const notificationWidth = '400px';

    let seconds = 5;

    const schainNodeOrderItem = this.schainNodeOrderItems.find(item => item.id === value);

    if (schainNodeOrderItem?.isPresentSellerId) {
      return;
    }

    const buildMessage = (timeLeft: number): string =>
      `To activate this option, please first fill in the required Seller ID value in the Custom Schain Settings. You'll be redirected to the corresponding page in ${timeLeft} second${timeLeft === 1 ? '' : 's'}`;

    // Show notification once with initial message and store reference to the data object
    this.errorsHandlingService.showNotification('error', 'error', 'error', buildMessage(seconds), notificationWidth);
    const notificationDataRef = this.notificationComponent.data;

    const intervalId = setInterval(() => {
      seconds -= 1;
      if (seconds > 0) {
        // Update the description inside the existing notification
        if (notificationDataRef) {
          notificationDataRef.description = buildMessage(seconds);
        }
      } else {
        clearInterval(intervalId);
        // Remove interval from tracking array after it's cleared
        const index = this.activeIntervals.indexOf(intervalId);
        if (index > -1) {
          this.activeIntervals.splice(index, 1);
        }
        window.open(`${origin}/sellers-json?openSchainModal=1&modalWidth=${modalWidth}&customSchainSettings=${schainNodeOrderItem?.parentId}`, '_blank');
      }
    }, 1000);
    // Track this interval so we can clear it if needed
    this.activeIntervals.push(intervalId);
  }

  public onChangeVideoWidthPresetsHandler(value: string[]): void {
    const videoSizeControl = this.editDSPForm.get('playerSizes')?.get('size');
    const videoSizeTriggerControl = this.editDSPForm.get('playerSizes')?.get('trigger');


    if (value.length > 0) {
      videoSizeControl?.patchValue([], { emitEvent: false });
      videoSizeControl?.disable({ emitEvent: false });
      videoSizeTriggerControl?.patchValue(1, { emitEvent: false });
      videoSizeTriggerControl?.disable({ emitEvent: false });
    } else {
      videoSizeControl?.enable({ emitEvent: false });
      videoSizeTriggerControl?.enable({ emitEvent: false });
    }
  }

  public onChangeVideoSizesHandler(value: string[]): void {
    const presetSizeControl = this.editDSPForm.get('presetPlayerSizes')?.get('size');
    const presetWidthTriggerControl = this.editDSPForm.get('presetPlayerSizes')?.get('trigger');

    if (value.length > 0) {
      presetSizeControl?.patchValue([], { emitEvent: false });
      presetSizeControl?.disable({ emitEvent: false });
      presetWidthTriggerControl?.patchValue(1, { emitEvent: false });
      presetWidthTriggerControl?.disable({ emitEvent: false });
    } else {
      presetSizeControl?.enable({ emitEvent: false });
      presetWidthTriggerControl?.enable({ emitEvent: false });
    }
  }

  public onChangeQPSAdapterHandler(value: boolean): void {
    if (!value) {
      this.formControls['min_rcpm'].patchValue(0, { emitEvent: false });
    }
  }

  public onValidateSpaceForNameHandler() {
    const nameControl = this.formControls['name'];
    if (nameControl.errors?.whitespace) {
      this.showNotification('error', 'error', 'error', '', 'Name cannot start with whitespace', '', '', 4500, 'normal');
    }
  }

  public onChangeRtbAdapterFieldHandler(_: Event, field: string | number, name: string): void {
    const fallbackTagIdItem = this.adaptersRtb.find(item => item.name === 'fallbackTagId');
    const hardcodedTagIdItem = this.adaptersRtb.find(item => item.name === 'hardcodedTagId');

    if (name === 'hardcodedTagId' && field !== '') {
      if (fallbackTagIdItem) {
        fallbackTagIdItem.disabled = true;
        fallbackTagIdItem.field = null;
      }
    } else if (name === 'hardcodedTagId' && field === '') {
      if (fallbackTagIdItem) {
        fallbackTagIdItem.disabled = false;
      }
    }


    if (name === 'fallbackTagId' && field !== '') {
      if (hardcodedTagIdItem) {
        hardcodedTagIdItem.disabled = true;
        hardcodedTagIdItem.field = null;
      }
    } else if (name === 'fallbackTagId' && field === '') {
      if (hardcodedTagIdItem) {
        hardcodedTagIdItem.disabled = false;
      }
    }

    this.isDisableSubmit = false;
  }

  public getIsRequiredAdapterField(itemName: string): boolean {
    return !!this.adaptersItem.config && !Array.isArray(this.adaptersItem.config)
      && this.adaptersItem.config.paramsReq?.[itemName]?.required || false;
  }

  public isRequiredPreBidField(itemName: string): boolean {
    return this.preBidItem.config.paramsReq[itemName]?.required ?? false;
  }

  public onChangeTabHandler(event: number): void {
    this.tabIndex = event;
  }

  public onCompanyChangeHandler(): void {
    this.isRequiredCompany = this.formValue.companyId == null;
  }

  public onAddCustomSizeHandler(input: HTMLInputElement, array: any[]): boolean {
    if (!this.isValidSizeInput(input.value)) {
      this.showSizeNotAllowedNotification();
      return false;
    }

    const wasAdded = this.addSizeToArrayIfUnique(input.value, array);
    if (wasAdded) {
      input.value = '';
    }
    return true;
  }

  public onValidateSizeHandler(event: KeyboardEvent): void {
    if (event.code.includes('Key')) {
      this.separator = event.key;
    }
  }

  public onChangeCheckedTCFHandler(_: boolean): void {
    if (!this.formValue.useTCF) {
      this.formControls['is_only_with_consent'].patchValue(0);
    }
  }

  public onChangePreBidServerHandler(server: string | number): void {
    this.resetPreBidFields();
    this.findPreBidItem(server);
    this.configureServerPreBid(server);
  }

  public onChangeCustomAdapterHandler(server: number): void {
    if (server === null) return;

    if (server === 0) {
      this.formControls['is_dual_schain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_dual_schain'].disable({ emitEvent: false });
      this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
    }

    this.adaptersFields = [];
    const adapterItem = this.rtbServers.find(item => item.id === server);
    if (adapterItem) {
      this.adaptersItem = adapterItem;
    }

    if (server === this.adapter_id && typeof this.formValue.adapter_config === 'string') {
      this.processAdapterConfig();
    } else {
      this.processRtbServer();
      this.updateShowFieldsStatus();
    }
  }

  public onResolveAdapterFieldsHandler() {
    if (!this.preBidItem) return;

    const adapterConfig = typeof this.formValue.adapter_config === 'string'
      ? JSON.parse(this.formValue.adapter_config)
      : this.formValue.adapter_config || {};

    Object.entries(adapterConfig).forEach(([key, value]) => {
      this.serverPreBid.push({ name: key, field: value, id: key });
    });
  }


  public onPreventInputHandler(event: Event, field: string) {
    const value = this.pixalatePBSettingsControls[field].value;

    if (value > 100) {
      event.preventDefault();

      return this.pixalatePBSettingsControls[field].patchValue(parseInt(value.toString().substring(0, 2)));
    }

    if (value < 0) {
      event.preventDefault();

      return this.pixalatePBSettingsControls[field].patchValue(0);
    }
  }

  public getBlockedIPsCount(): number {
    return this.formValue.blockedIPsCount;
  }

  public getTooltipForAdapter(name: string): string {
    return name === 'Freewheel' && !this.formValue.video
      ? 'Available with the Video ad format' :
      '';
  }

  public isDisabledOption(adapterName: string): boolean {
    if (!this.partnerSettings.has_rubicon_settings && adapterName === 'Rubicon Inactive' && this.isDisabledRubiconOption) {
      return true;
    }

    if (adapterName === '33Across' && this.formValue.rtb_type !== '2.5') {
      return true;
    }

    if (adapterName === 'Freewheel' && !this.formValue.video) {
      return true;
    }

    if (adapterName === 'Tappx' && !(this.formValue.video || this.formValue.banner)) {
      return true;
    }

    return false;
  }

  public get isFreewheelAdapter(): boolean {
    const adapter = this.rtbAdapters.find(item => item.id === this.formValue['adapter_id']);
    return adapter?.name === 'Freewheel';
  }

  public onFreewheelKeywordsToggleHandler(value: boolean): void {
    this.isFreewheelKeywordsEnabled = value;
  }

  public get isFreewheelKvAtMax(): boolean {
    return this.freewheelKeyValuePairs.length >= this.FREEWHEEL_KV_MAX_PAIRS;
  }

  public get freewheelKvDuplicateKeys(): Set<string> {
    const seen = new Set<string>();
    const duplicates = new Set<string>();
    this.freewheelKeyValuePairs.forEach(p => {
      const k = this.normalizeFreewheelKey(p.key);
      if (!k) { return; }
      if (seen.has(k)) { duplicates.add(k); } else { seen.add(k); }
    });
    return duplicates;
  }

  public addFreewheelKeyValuePair(): void {
    if (!this.isFreewheelKvAtMax) {
      this.freewheelKeyValuePairs.push({ key: '', value: '' });
    }
  }

  public removeFreewheelKeyValuePair(index: number): void {
    this.freewheelKeyValuePairs.splice(index, 1);
  }

  public getIsDisabledPreBidOption(serverName: string): boolean {
    const requiredFormats = this.preBidServerRequiredFormats[serverName];

    if (!requiredFormats) {
      return false;
    }

    return !requiredFormats.some(format => this.formValue[format]);
  }

  public getTooltipForPreBidServer(serverName: string): string {
    const requiredFormats = this.preBidServerRequiredFormats[serverName];

    if (!requiredFormats || requiredFormats.some(format => this.formValue[format])) {
      return '';
    }

    const formatNames = requiredFormats.map(format => {
      return format.charAt(0).toUpperCase() + format.slice(1);
    });

    const formattedList = formatNames.join(' or ');

    return `Only available with the ${formattedList} Ad Formats`;
  }

  public onChangeFieldHandler(_: Event) {
    this.isDisableSubmit = false;
  }

  public onFormSubmitHandler(callback: (type: string) => void): boolean | void {
    const restrictedConnectionTypes = [4, 5];

    if (this.partner.partner_plan === 3 && restrictedConnectionTypes.includes(this.formValue.connectionType)) {
      this.viewerRestrictionService.restrictByPartnerPlan();
      return;
    }

    if (this.userRole === UserRole.viewer) {
      this.viewerRestrictionService.restrictUserViewer();
      return;
    }

    this.disableSubmitButton();
    if (!this.validateForm()) {
      return false;
    }

    this.prepareFormForSubmission();
    this.submitFormBasedOnConnectionType(callback);
  }

  public onCloseModalHandler(callback: (type: string) => void) {
    this.companiesSSPDropdown = [];
    this.tabIndex = 0;
    this.editDSPForm.reset({}, { emitEvent: false });
    callback('cancel');
  }

  public onEditBlockAllowItemsHandler(type: string) {
    const dialogRef = this.modalService.create({
      nzContent: BlockAllowEndpointsDialogComponent,
      nzCentered: true,
      nzMaskClosable: false,
      nzStyle: { width: '450px', height: '200px' },
      nzBodyStyle: { width: '450px', padding: '0px', height: '100px' },
      nzFooter: null,
      nzClosable: false,
      nzData: {
        endpointType: 'dsp', endpoint: this.formValue, listType: type,
      }
    });
    dialogRef.afterClose.subscribe((res: { itemsCount: number, type: string, list: string[] }) => {
      if (res && res.type === 'sites') {
        this.formValue.allowedSitesCount = res.itemsCount;
        return false;
      }
      if (res && res.type === 'blocked-sites') {
        this.formValue.blockedSitesCount = res.itemsCount;
        return false;
      }
      if (res && res.type === 'blocked-ips') {
        this.formValue.blockedIPsCount = res.itemsCount;
        return false;
      }
      return true; // Ensure all code paths return a value
    });
  }

  public onEndpointChangeHandler(event: Event): boolean {
    this.formControls['endpoint'].patchValue((event.target as HTMLInputElement).value);
    if (!this.isJSConnection()) {
      return false;
    }
    return true;
  }

  public onShowMacrosListHandler(macrosListContentHeight: string, macrosListBodyHeight: string): void {
    this.modalService.create({
      nzContent: MacrosListComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'macros-list-modal',
      nzWrapClassName: 'macros-list-modal-wrap',
      nzStyle: { top: '30px', width: '650px', height: macrosListContentHeight },
      nzBodyStyle: { width: '650px', padding: '0px', height: macrosListBodyHeight, overflowY: 'scroll' },
      nzData: {
        macrosList: this.isJSConnection() ? this.macrosListJs : this.listOfMacros,
      }
    });
    return;
  }

  public async onApiLinkTestHandler(link: string, event: Event): Promise<void> {
    event.preventDefault();
    const resp = await this.mainService.testApiLink(link);
    this.modalService.create({
      nzMaskClosable: false,
      nzContent: CompaniesTestLinkComponent,
      nzData: {
        apitest: resp,
      }
    });
    return;
  }

  public onLinkCopyHandler(event: MouseEvent, label: string): void {
    (event.target as HTMLButtonElement).textContent = 'Copied!';
    setTimeout(() => { (event.target as HTMLButtonElement).textContent = label; }, 1200);
  }

  public onDeleteEndpointHandler(endpoint: PlatformInterface.IPlatformDSP, callback: (type: string) => void): void {
    this.openDeleteConfirmationDialog(endpoint)
      .afterClose.subscribe(res => {
        if (res) {
          this.deleteEndpoint(endpoint, callback);
        }
      });
  }


  public onDuplicateEndpointHandler(endpointId: number, callback: (type: string) => void): void {
    this.showLoading();
    this.duplicateEndpoint(endpointId)
      .pipe(finalize(() => this.hideLoading()))
      .subscribe(
        () => this.handleDuplicateSuccess(callback),
        (err) => this.handleError(err)
      );
  }

  public onValidateLinkHandler(link: string, event: Event): void {
    event.preventDefault();
    this.apiLink = link;
    this.isDisableSubmit = false;
  }

  public getError(value: boolean): void {
    this.isDisabledTest = value;
  }

  public isRtbConnection(): boolean {
    return this.formValue.connectionType === 0;
  }

  public isVastConnection(): boolean {
    return this.formValue.connectionType === 1;
  }

  public isJSConnection(): boolean {
    return this.formValue.connectionType === 3;
  }

  public isPreBidConnection(): boolean {
    return this.formValue.connectionType === 4;
  }

  public botmanPreBidIsEnabled(): boolean {
    return !!this.auth.partner.botman_settings?.enable_prebid;
  }

  public onChangeSizeHandler(id: number): void {
    const elementSize = id ? this.listOfSizes.find(element => element.id === id) : { width: 0, height: 0 };
    if (elementSize) {
      this.jsControls['w'].patchValue(elementSize.width);
      this.jsControls['h'].patchValue(elementSize.height);
    }
  }

  public onChangeMarginTypeHandler(_: string): void {
    this.resetMargins();
    if (this.formValue.margin_type === 'range') {
      this.setRangeArrayMargin();
    } else if (this.formValue.margin_type === 'fixed') {
      this.setFixedArrayMargins();
    } else if (this.formValue.margin_type === 'adaptive') {
      this.setAdaptiveArrayMargin();
    }
  }

  private updateSizesVisibility(partial?: Partial<Record<'video' | 'rewarded' | 'banner' | 'native', boolean>>): void {
    const current = this.formValue;
    const video = partial?.video ?? !!current.video;
    const rewarded = partial?.rewarded ?? !!current.rewarded;
    const banner = partial?.banner ?? !!current.banner;
    const native = partial?.native ?? !!current.native;

    const onlyNative = native && !video && !rewarded && !banner;
    const showVideoSizes = video || rewarded || onlyNative;
    const showBannerSizes = banner || native;

    this.isShowVideoSizes = showVideoSizes;
    this.isShowBannerSizes = showBannerSizes;

    // controls
    const videoSizeControl = this.editDSPForm.get('playerSizes')?.get('size');
    const videoSizeTriggerControl = this.editDSPForm.get('playerSizes')?.get('trigger');
    const presetSizeControl = this.editDSPForm.get('presetPlayerSizes')?.get('size');
    const presetWidthTriggerControl = this.editDSPForm.get('presetPlayerSizes')?.get('trigger');
    const bannerSizeControl = this.editDSPForm.get('sizesList');
    const bannerSizeTriggerControl = this.editDSPForm.get('sizeTrigger');

    if (!showVideoSizes) {
      videoSizeControl?.patchValue([], { emitEvent: false });
      videoSizeTriggerControl?.patchValue(1, { emitEvent: false });
      presetSizeControl?.patchValue([], { emitEvent: false });
      presetWidthTriggerControl?.patchValue(1, { emitEvent: false });
      videoSizeControl?.enable({ emitEvent: false });
      videoSizeTriggerControl?.enable({ emitEvent: false });
      presetSizeControl?.enable({ emitEvent: false });
      presetWidthTriggerControl?.enable({ emitEvent: false });
    }

    if (!showBannerSizes) {
      bannerSizeControl?.patchValue([], { emitEvent: false });
      bannerSizeTriggerControl?.patchValue(1, { emitEvent: false });
    }
  }

  public onShowConsentConfirmModalHandler(value: boolean): void {
    if (value) {
      const dialogRef = this.modalService.create({
        nzContent: ConsentConfirmComponent,
        nzMaskClosable: false,
        nzClosable: false,
        nzClassName: 'consent-confirm-modal',
        nzWrapClassName: 'consent-confirm-modal-wrap',
        nzStyle: { width: '650px', height: 'auto' },
        nzBodyStyle: { width: '650px', padding: '0px', height: 'auto' },
        nzCentered: true,
        nzFooter: null,
      });

      dialogRef.afterClose.subscribe((res: boolean) => {
        if (res) {
          this.formControls['is_only_with_consent'].patchValue(true, { emitEvent: false });
        } else {
          this.formControls['is_only_with_consent'].patchValue(false, { emitEvent: false });
        }
      });
    }
  }


  private getAdTypeMacrosParams(item: any): string[] {
    const params: string[] = [];
    const macroses = item.adTypeMacroses[this.formValue.adtype];
    for (const macros in macroses) {
      params.push(`${macroses[macros].shortcut}=${macroses[macros].macros}`);
    }
    return params;
  }

  private getControlsToResetBasedOnMarginType(): string[] {
    switch (this.formValue.margin_type) {
      case 'range':
        return ['margin'];
      case 'fixed':
        return ['min_margin', 'max_margin'];
      case 'adaptive':
        return ['margin', 'min_margin', 'max_margin'];
      default:
        return [];
    }
  }

  private resetMargins(): void {
    this.arrayOfMargins = [];
    this.resetFormMarginValues();
  }

  private resetFormMarginValues(): void {
    this.formControls.margin.patchValue(undefined);
    this.formControls.min_margin.patchValue(undefined);
    this.formControls.max_margin.patchValue(undefined);
  }

  private setRangeArrayMargin(): void {
    this.arrayOfMargins = [
      { key: 'min_margin', minValue: 1, maxValue: 100 },
      { key: 'max_margin', minValue: 1, maxValue: 100 }
    ];
    this.formControls.margin.patchValue(undefined);
  }

  private setFixedArrayMargins(): void {
    this.arrayOfMargins = [{ key: 'margin', minValue: 0, maxValue: 100 }];
    this.formControls.min_margin.patchValue(undefined);
    this.formControls.max_margin.patchValue(undefined);
  }

  private setAdaptiveArrayMargin(): void {
    this.resetMargins();
  }

  private get formControls(): { [key: string]: FormControl } {
    return this.editDSPForm.controls as { [key: string]: FormControl };
  }

  private get jsControls(): { [key: string]: FormControl } {
    return (this.editDSPForm.get('js') as FormGroup).controls as { [key: string]: FormControl };
  }

  private getAdType() {
    this.onCheckAdTypeMobileWeb();
    this.onCheckAdTypeDesktop();
    this.onCheckAdTypeInApp();
    this.onCheckAdTypeCtv();
  }

  private getJsAdType(): void {
    this.onCheckJsAdTypeApp();
    this.onCheckJsAdTypeDesktop();
    this.onCheckJsAdTypeWeb();
    if (this.formValue.jsAdType === '') {
      this.formControls['jsAdType'].patchValue('mobileWeb');
    }
  }

  private onCheckAdTypeMobileWeb() {
    if (this.formValue.mobileWeb) {
      this.formControls['adtype'].patchValue('mobileWeb');
    }
  }

  private onCheckAdTypeDesktop() {
    if (this.formValue.desktop) {
      this.formControls['adtype'].patchValue('desktop');
    }
  }

  private onCheckAdTypeInApp() {
    if (this.formValue.inApp) {
      this.formControls['adtype'].patchValue('inApp');
    }
  }

  private onCheckAdTypeCtv() {
    if (this.formValue.ctv) {
      this.formControls['adtype'].patchValue('ctv');
    }
  }

  private onCheckJsAdTypeWeb(): void {
    if (this.formValue.mobileWeb) {
      this.formControls['jsAdType'].patchValue('mobileWeb');
    }
  }

  private onCheckJsAdTypeApp(): void {
    if (this.formValue.inApp) {
      this.formControls['jsAdType'].patchValue('inApp');
    }
  }

  private onCheckJsAdTypeDesktop(): void {
    if (this.formValue.desktop) {
      this.formControls['jsAdType'].patchValue('desktop');
    }
  }

  private fetchAdapters(): Observable<any> {
    return this.mainService.getAdaptersByType({ is_prebid: false, type: 'dsp' });
  }

  private readonly preBidServerRequiredFormats: Record<string, Array<'banner' | 'native' | 'video'>> = {
    'Streamlyn-Prebid': ['banner', 'native', 'video'],
    'Insticator-Prebid': ['banner', 'video'],
    'Online Media Solutions-Prebid': ['banner', 'video'],
    'Index Exchange-Prebid': ['banner', 'native', 'video'],
    'Rise-Prebid': ['banner', 'native', 'video'],
    'Vidazoo-Prebid': ['banner', 'video'],
    'AdMatic GMBH-Prebid': ['banner', 'native', 'video'],
    'Afront-Prebid': ['banner', 'native', 'video'],
    'AMX-Prebid': ['banner', 'video'],
    'Seedtag-Prebid': ['banner', 'video'],
    'Microsoft-Prebid': ['banner', 'native', 'video'],
  };

  private processAdapters(res: any, endpointData: PlatformInterface.IResponseDSPById): void {
    this.prependNoneAdapter(res, endpointData);
    this.findSelectedAdapter();
    this.setRtbAdapters(endpointData);
  }

  private prependNoneAdapter(res: any, endpointData: PlatformInterface.IResponseDSPById): void {
    const fieldsNone = {
      name: 'None',
      id: 0,
      fields: [],
      config: {},
    };
    this.rtbServers = [fieldsNone, ...res];
    this.rtbServers.forEach(item => this.updateRubiconNameIfNeeded(item, endpointData));
  }

  private findSelectedAdapter(): void {
    const adapterItem = this.rtbServers.find(item => item.id === this.formValue.adapter_id);
    if (adapterItem) {
      this.adaptersItem = adapterItem;
    }
  }

  private setRtbAdapters(resp: PlatformInterface.IResponseDSPById): void {
    this.isDisabledRubiconOption = !this.partnerSettings?.has_rubicon_settings;

    let config: Record<string, any> | null = null;
    const rawConfig = resp?.data?.adapter_config;

    if (typeof rawConfig === 'string' && rawConfig.trim().length) {
      try {
        config = JSON.parse(rawConfig);
      } catch {
        config = null;
      }
    }

    if (config && typeof config === 'object') {
      const paramsReq = this.adaptersItem?.config?.paramsReq ?? {};

      const toggleChildren = new Set<string>();
      for (const key of Object.keys(paramsReq)) {
        const param = paramsReq[key];
        if (param?.type === 'toggle' && Array.isArray(param.children)) {
          param.children.forEach((child: string) => toggleChildren.add(child));
        }
      }

      const entries = Object.entries(config).filter(([name]) => {
        const param = paramsReq[name];
        return param?.type !== 'toggle' && param?.type !== 'object' && !toggleChildren.has(name);
      });

      this.adaptersRtb = entries.map(([name, field], index) => ({
        name,
        field,
        id: index,
        tooltip: paramsReq[name]?.tooltip ?? null,
        disabled: false,
      }));

      if (this.adaptersItem?.name === 'CustomTagIdPubId') {
        this.applyMutualExclusionForFields('hardcodedTagId', 'fallbackTagId');
        this.applyMutualExclusionForFields('fallbackTagId', 'hardcodedTagId');
      }
    } else {
      this.adaptersRtb = [];
    }

    this.updateShowFieldsStatus();
  }

  private applyMutualExclusionForFields(primaryFieldName: string, secondaryFieldName: string): void {
    const primary = this.adaptersRtb.find(item => item.name === primaryFieldName);
    const secondary = this.adaptersRtb.find(item => item.name === secondaryFieldName);

    if (!primary || !secondary) return;

    if (primary.field !== null) {
      secondary.disabled = true;
      secondary.field = null;
    } else {
      secondary.disabled = false;
    }
  }


  private updateRubiconNameIfNeeded(item: any, endpointData: PlatformInterface.IResponseDSPById): void {
    if (item.name === 'Rubicon' && !this.partnerSettings.has_rubicon_settings) {
      item.name = 'Rubicon Inactive';
    } else if (item.name === 'CustomExtensions') {
      item.name = 'Custom Extensions';
    }

    this.rtbAdapters = this.rtbServers.map(({ id, name, config }) => ({ id, name, config }));

    this.loadFreewheelKeywordsFromResponse(endpointData.data);
  }

  private displayErrorMessages(errorMessages: string[]): boolean {
    if (errorMessages.length) {
      errorMessages.forEach(errorMessage => this.showNotification('error', 'error', 'error', '', errorMessage, '', '', 4500, 'normal'));
      return false;
    }
    return true;
  }

  private markDefaultPriceVastAsTouched() {
    this.formControls['defaultPriceVast'].markAsTouched();
  }

  private checkIfDefaultPriceIsRequired(errors: string[]): string[] {
    if (this.formControls['defaultPriceVast'] && this.formControls['defaultPriceVast'].status === 'INVALID') {
      errors.push('Fixed Price is required');
    }
    return errors;
  }

  private checkIfDefaultPriceIsInteger(errors: string[]): string[] {
    if (this.formControls['defaultPriceVast'] &&
      this.formControls['defaultPriceVast'].value && !/^([0-9]*[.])?[0-9]+$/.test(this.formControls['defaultPriceVast'].value)) {
      errors.push('Fixed Price must be an integer.');
      this.formControls['defaultPriceVast'].setErrors({ 'incorrect': true });
    }
    return errors;
  }

  private checkIfDefaultPriceIsGreaterThanZero(errors: string[]): string[] {
    if (
      this.formControls['defaultPriceVast'] &&
      this.formControls['defaultPriceVast'].value !== null &&
      this.formControls['defaultPriceVast'].value !== undefined &&
      (this.formControls['defaultPriceVast'].value === 0 ||
        this.formControls['defaultPriceVast'].value < 0)
    ) {
      errors.push('Fixed Price must be greater than 0.');
      this.formControls['defaultPriceVast'].setErrors({ 'incorrect': true });
    }
    return errors;
  }

  private checkIVTValues(errorMessages: string[]): string[] {
    const suspiciousIVT = this.formControls['pmPrebidSuspiciousIVT'].value;
    const fraudIVT = this.formControls['pmPrebidFraudIVT'].value;
    const ivtRegex = /^[1-9]$|^[1-9][0-9]$|^(100)$/;

    if (suspiciousIVT && !ivtRegex.test(suspiciousIVT)) {
      errorMessages.push('Public Media Suspicious IVT must be between 0 and 100');
    }

    if (fraudIVT && !ivtRegex.test(fraudIVT)) {
      errorMessages.push('Public Media Fraud IVT must be between 0 and 100');
    }

    return errorMessages;
  }

  private updateSchainNodeOrderItems(companyId: number): void {
    const defaultItems: SelectItemsInterface.ISchainNodeOrder[] = [
      { id: 1, name: 'Default order', isPresentSellerId: true, parentId: 0 }
    ];

    const customNode = this.schainValues.find(item => item.id === companyId);

    if (!customNode || companyId === 1) {
      this.schainNodeOrderItems = defaultItems;
      return;
    }

    const schainNodeOrderItems = [
      ...defaultItems,
      { id: 2, name: `Default + ${customNode.sellerName}`, isPresentSellerId: customNode.defaultCustomSellerId ? true : false, parentId: customNode.id },
      { id: 3, name: `${customNode.sellerName} + Default`, isPresentSellerId: customNode.customDefaultSellerId ? true : false, parentId: customNode.id },
    ];

    this.schainNodeOrderItems = schainNodeOrderItems;
    this.appConfig.schainNodeOrderItems$.next(schainNodeOrderItems);
  }


  private validateDefaultPriceVast(errors: string[]): string[] {
    if (this.tabIndex === 0 && this.formValue.connectionType === 1) {
      this.markDefaultPriceVastAsTouched();
      errors = this.checkIfDefaultPriceIsRequired(errors);
      errors = this.checkIfDefaultPriceIsInteger(errors);
      errors = this.checkIfDefaultPriceIsGreaterThanZero(errors);
    }
    return errors;
  }

  private validateEndpointURL(errorMessages: string[]): string[] {
    const endpointControl = this.editDSPForm.get('endpoint') as FormControl | null;
    if (!endpointControl) return errorMessages;

    if (endpointControl.errors?.required) {
      errorMessages.push('Endpoint is required');
    }

    if (endpointControl.errors?.invalidEndpoint) {
      errorMessages.push('Endpoint must be a valid URL');
    }

    return errorMessages;
  }

  private validateCompany(errors: string[]): string[] {
    this.isRequiredCompany = this.isCompanyRequired();
    if (this.isRequiredCompany) {
      errors.push('Company is required');
    }
    return errors;
  }

  private validateRegion(errors: string[]): string[] {
    this.isRequiredRegion = this.isRegionRequired();
    if (this.isRequiredRegion) {
      errors.push('Region is required');
    }
    return errors;
  }

  private validateJsCPM(errors: string[]): string[] {
    if (!this.formValue.js.cpm && this.isJSConnection()) {
      errors.push('CPM is required');
      const cpmControl = this.formControls['js']?.get('cpm');
      if (cpmControl) {
        cpmControl.setErrors({ invalid: true });
        cpmControl.markAsTouched();
      }
    }
    return errors;
  }

  private validateJsHeight(errors: string[]): string[] {
    if (!this.formValue.js.h && this.isJSConnection()) {
      errors.push('Height is required');
      const hControl = this.editDSPForm.get('js')?.get('h');
      if (hControl) {
        hControl.setErrors({ invalid: true });
        hControl.markAsTouched();
      }
    }
    return errors;
  }

  private validateJsWidth(errors: string[]): string[] {
    if (!this.formValue.js.w && this.isJSConnection()) {
      errors.push('Width is required');
      const wControl = this.editDSPForm.get('js')?.get('w');
      if (wControl) {
        wControl.setErrors({ invalid: true });
        wControl.markAsTouched();
      }
    }
    return errors;
  }

  private validateSpendLimit(errors: string[]): string[] {
    if (!this.formValue.spendLimit && this.isJSConnection()) {
      errors.push('Spend Limit is required');
    }
    return errors;
  }

  private validateQPSLimit(errors: string[]): string[] {
    if (!this.formValue.limitQPS) {
      errors.push('QPS Limit is required');
    }
    return errors;
  }

  private validateTrafficType(errors: string[]): string[] {
    if (this.isRtbConnection() || this.isPreBidConnection()) {
      errors = this.validateGenericTrafficType(errors);
    }

    if (this.isVastConnection()) {
      errors = this.validateVastTrafficType(errors);
    }

    return errors;
  }

  private validateGenericTrafficType(errors: string[]): string[] {
    const trafficTypes = ['mobileWeb', 'desktop', 'inApp', 'ctv'];
    const checkedAtLeastOneType = trafficTypes.some(type => this.formValue[type]);
    return this.updateTrafficTypeValidation(checkedAtLeastOneType, errors);
  }

  private validateVastTrafficType(errors: string[]): string[] {
    const validTypes = ['mobileWeb', 'inApp', 'desktop', 'ctv'];
    const checkedAtLeastOneType = validTypes.includes(this.formValue.adtype);
    return this.updateTrafficTypeValidation(checkedAtLeastOneType, errors);
  }

  private validateAdFormat(errors: string[]): string[] {
    if (this.isRtbConnection() || this.isPreBidConnection() || this.isVastConnection()) {
      errors = this.validateAdFormatSelection(errors);
    }
    return errors;
  }

  private validateMargin(errors: string[], arrayOfMargins: { key: string, minValue: number, maxValue: number }[]): string[] {
    this.validateMarginRange(errors);
    arrayOfMargins.forEach(margin => this.validateMarginValue(errors, margin));
    return errors;
  }

  private validateAdFormatSelection(errors: string[]): string[] {
    const adFormats = ['banner', 'native', 'video', 'rewarded', 'audio'];
    const checkedAtLeastOneFormat = adFormats.some(format => this.formValue[format]);
    this.isRequiredAdFormat = this.tabIndex === 0 && !checkedAtLeastOneFormat;
    if (this.isRequiredAdFormat) {
      errors.push('Please select at least one ad format.');
    }
    return errors;
  }

  private validateMarginRange(errors: string[]): void {
    if (this.formValue.margin_type === 'range' && this.isInvalidMarginRange()) {
      this.setMarginErrors();
      errors.push('Maximum margin value must be greater than minimum margin value');
    }
  }

  private validateMarginValue(errors: string[], margin: { key: string, minValue: number, maxValue: number }): void {
    if (this.formValue[margin.key] !== null && this.formValue[margin.key] !== undefined) {
      if (this.formValue[margin.key] < margin.minValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be lower than ${margin.minValue}`);
      } else if (this.formValue[margin.key] > margin.maxValue) {
        errors.push(`${this.marginKeys[margin.key]} value must not be higher than ${margin.maxValue}`);
      }
    } else {
      errors.push(`${this.marginKeys[margin.key]} is required`);
    }
  }


  private validateSchainSourceFileChecked(errors: string[]): string[] {
    if (this.formValue.schain_source && this.formControls['dsp_schain_source_file_id'].errors?.required) {
      errors.push('Please select the Source Schain File');
    }
    return errors;
  }

  private validateTabSpecificFields(errorMessages: string[]): string[] {
    if (this.tabIndex === 0) {
      errorMessages = this.validateDefaultPriceVast(errorMessages);
      errorMessages = this.validateTrafficType(errorMessages);
      errorMessages = this.validateAdFormat(errorMessages);
      errorMessages = this.validateCompany(errorMessages);
      errorMessages = this.validateRegion(errorMessages);
      errorMessages = this.validateJsCPM(errorMessages);
      errorMessages = this.validateJsHeight(errorMessages);
      errorMessages = this.validateJsWidth(errorMessages);
      errorMessages = this.validateSpendLimit(errorMessages);
      errorMessages = this.validateMargin(errorMessages, this.arrayOfMargins);
      errorMessages = this.validateName(errorMessages);
      errorMessages = this.validateQPSLimit(errorMessages);
    }
    return errorMessages;
  }

  private validateIVTFields(errorMessages: string[]): string[] {
    if (this.tabIndex === 2 && this.partnerSettings.usePMPreBid) {
      this.markIVTFieldsAsTouched();
      errorMessages = this.checkIVTValues(errorMessages);
    }
    return errorMessages;
  }

  private validateName(errors: string[]): string[] {
    const { name } = this.editDSPForm.controls;
    this.appendMaxLengthError(errors, name as FormControl);
    this.appendRequiredError(errors, name as FormControl);
    return errors;
  }

  private setMarginErrors(): void {
    this.formControls['min_margin'].setErrors({ invalid: true });
    this.formControls['max_margin'].setErrors({ invalid: true });
  }

  private updateTrafficTypeValidation(checkedAtLeastOneType: boolean, errors: string[]): string[] {
    if (this.tabIndex === 0 && !checkedAtLeastOneType) {
      this.isRequiredTrafficType = true;
      errors.push('Please select at least one traffic type.');
    } else {
      this.isRequiredTrafficType = false;
    }
    return errors;
  }

  private appendMaxLengthError(errors: string[], control: FormControl): void {
    const maxLengthError = control.errors?.maxlength;
    if (maxLengthError) {
      errors.push(`You have reached your maximum limit of characters allowed. Required length is ${maxLengthError.requiredLength}, but you entered ${maxLengthError.actualLength}`);
    }
  }

  private appendRequiredError(errors: string[], control: FormControl): void {
    if (control.errors?.required) {
      errors.push('Name is required');
    }
  }

  private markAllFormControlsAsTouched() {
    for (const i in this.formControls) {
      this.formControls[i].markAsTouched();
    }
  }

  private markConditionalFieldsAsTouched() {
    if (this.formValue.useTotalSpendLimit) {
      this.requiredFields.totalSpendLimit = 'Total spend limit';
      this.formControls['totalSpendLimit'].markAsTouched();
    }

    if (this.isJSConnection() && this.tabIndex === 0) {
      this.formControls['spendLimit'].markAsTouched();
    }
  }

  private markIVTFieldsAsTouched() {
    this.formControls['pmPrebidSuspiciousIVT']?.markAsTouched();
    this.formControls['pmPrebidFraudIVT']?.markAsTouched();
  }

  private isCompanyRequired(): boolean {
    return this.formValue.companyId === undefined || this.formValue.companyId === null;
  }


  private isRegionRequired(): boolean {
    return this.formValue.region === undefined || this.formValue.region === null;
  }

  private isInvalidMarginRange(): boolean {
    return this.formValue.min_margin >= this.formValue.max_margin && (this.formValue.min_margin !== null || this.formValue.max_margin !== null);
  }

  private checkRequiredFields(requiredFields: any, errorMessages: string[]): string[] {
    for (const i in requiredFields) {
      if (this.formControls[i] && this.formControls[i].status == 'INVALID' && requiredFields[i].length !== 0) {
        errorMessages.push(`${requiredFields[i]} is required`);
      }
    }
    return errorMessages;
  }

  private initializeErrorMessages(): string[] {
    let errorMessages: string[] = [];
    const requiredFields = this.requiredFields;

    this.markConditionalFieldsAsTouched();
    errorMessages = this.checkRequiredFields(requiredFields, errorMessages);

    return errorMessages;
  }

  private handleErrors() {
    this.markAllFormControlsAsTouched();
    let errorMessages: string[] = this.initializeErrorMessages();

    errorMessages = this.validateTabSpecificFields(errorMessages);
    errorMessages = this.validateIVTFields(errorMessages);
    errorMessages = this.validateSchainSourceFileChecked(errorMessages);

    if (this.isRtbConnection()) {
      errorMessages = this.validateEndpointURL(errorMessages);
    }

    if (this.isFreewheelAdapter && this.isFreewheelKeywordsEnabled && this.freewheelKvDuplicateKeys.size > 0) {
      const keys = Array.from(this.freewheelKvDuplicateKeys).join(', ');
      errorMessages.push(`Custom Key-Value Pair contains duplicate keys: ${keys}`);
    }

    return this.displayErrorMessages(errorMessages);
  }

  private recognizeSelectedSize() {
    const selectedSize = this.listOfSizes.find(size => size.height === this.formValue.js.h && size.width === this.formValue.js.w);
    if (selectedSize) {
      this.formControls['selectedSize'].patchValue(selectedSize.id);
    }
  }

  private setArrayOfMargins(): void {
    const marginTypeActions = {
      'range': this.setRangeMargins,
      'fixed': this.setFixedMargin,
      'adaptive': this.setAdaptiveMargin
    };

    const action = marginTypeActions[this.formValue.margin_type];
    if (action) {
      this.arrayOfMargins = action.call(this);
    }
  }

  private setRangeMargins(): { key: string; minValue: number; maxValue: number }[] {
    return [
      { key: 'min_margin', minValue: 1, maxValue: 100 },
      { key: 'max_margin', minValue: 1, maxValue: 100 }
    ];
  }

  private setFixedMargin(): { key: string; minValue: number; maxValue: number }[] {
    return [{ key: 'margin', minValue: 0, maxValue: 100 }];
  }

  private setAdaptiveMargin(): { key: string; minValue: number; maxValue: number }[] {
    return [];
  }

  private setMargin(): void {
    const controlsToReset = this.getControlsToResetBasedOnMarginType();
    controlsToReset.forEach(control => this.formControls[control].patchValue(undefined));
  }

  private setMarginOnInit(initData: PlatformInterface.IResponseDSPById): void {
    if (initData.data.margin_type === 'fixed') {
      this.formControls['margin'].patchValue(initData.data.margin);
    }

    if (initData.data.margin_type === 'range') {
      this.formControls['min_margin'].patchValue(initData.data.min_margin);
      this.formControls['max_margin'].patchValue(initData.data.max_margin);
    }
  }

  private setNativeSpec(): void {
    const includesAllElements = [1, 2, 3].every(element => this.formValue.nativeSpec.includes(element));
    this.formControls['nativeSpec'].patchValue(includesAllElements ? [-1] : this.formValue.nativeSpec);
  }

  private setBannerSizeListArray(): void {
    const sizesListSafe: any[] = this.formValue.sizesList ?? [];

    const array = sizesListSafe.map(element => ({ id: element, name: element }));

    this.sizesList = Array.from(
      new Map(
        [...this.sizesList, ...array].map(item => [item.id, item])
      ).values()
    );
  }

  private setVideoSizeListArray(): void {
    const sizesListSafe: string[] = this.formValue.playerSizes.size ?? [];

    const array = sizesListSafe.map(element => ({ id: element, name: element }));

    this.videoSizesList = Array.from(
      new Map(
        [...this.videoSizesList, ...array].map(item => [item.id, item])
      ).values()
    );
  }

  private handleJS(): void {
    this.getJsAdType();
    this.recognizeSelectedSize();
    const sizeExists = this.listOfSizes.some(element => element.height === this.formValue.js.h && element.width === this.formValue.js.w);
    if (!sizeExists) {
      this.formControls['selectedSize'].patchValue(0);
    }
  }

  private handleVast(): void {
    this.getAdType();
    if (this.formValue.adServerId != null) {
      this.adServers.forEach(item => this.updateVastTemplateIfMatch(item));
    }
  }

  private loadFreewheelKeywordsFromResponse(data: any): void {
    if (!this.isFreewheelAdapter) {
      return;
    }

    let config: Record<string, any> = {};
    const rawConfig = data?.adapter_config;
    if (typeof rawConfig === 'string' && rawConfig.trim().length) {
      try { config = JSON.parse(rawConfig); } catch { config = {}; }
    } else if (rawConfig && typeof rawConfig === 'object') {
      config = rawConfig;
    }

    this.isFreewheelKeywordsEnabled = !!Number(config['_indicateToggle']);

    console.log('config', config);

    this.freewheelKeywordsData = {
      timezone: config['timezone'] ?? '',
      city: config['city'] ?? '',
      dma: config['dma'] ?? '',
      state: config['state'] ?? '',
      programmer_brand: config['programmerBrand'] ?? '',
      channel: config['channel'] ?? '',
      genre: config['genre'] ?? '',
      language: config['language'] ?? '',
      content_rating: config['contentRating'] ?? '',
      content_stream_mode: config['contentStreamMode'] ?? '',
    };

    const customObj = config['custom'];
    if (customObj && typeof customObj === 'object' && !Array.isArray(customObj)) {
      const pairs = Object.entries(customObj).map(([key, value]) => ({ key, value: String(value) }));
      this.freewheelKeyValuePairs = pairs.length > 0 ? pairs : [{ key: '', value: '' }];
    } else {
      this.freewheelKeyValuePairs = [{ key: '', value: '' }];
    }
  }

  private normalizeFreewheelKey(key: string): string {
    return key.trim().replace(/^["']+|["']+$/g, '').trim();
  }

  private updateVastTemplateIfMatch(item: any): void {
    if (this.isAdServerMatch(item)) {
      this.vastTemplate = item.adTypeUrls[this.formValue.adtype].url;
      const params = this.getAdTypeMacrosParams(item);
      if (params.length > 0) {
        this.vastTemplate += '?' + params.join('&');
      }
    }
  }

  private isAdServerMatch(item: any): boolean {
    return item.adTypes[this.formValue.adtype] && item.id === this.formValue.adServerId;
  }

  private patchFormControlsBasedOnAdType(): void {
    const adTypes = ['ctv', 'mobileWeb', 'desktop', 'inApp'];
    adTypes.forEach(adType => {
      this.formControls[adType].patchValue(this.formValue.adtype === adType);
    });
  }

  private prepareVastData(modifiedSSPList: number[], selectedCountries: string[]): any {
    return {
      ...this.formValue,
      nativeSpec: this.getNativeSpec(),
      sspList: modifiedSSPList,
      countriesList: selectedCountries
    };
  }

  private getNativeSpec(): number[] {
    return this.formValue.nativeSpec.includes(-1) ? [1, 2, 3] : this.formValue.nativeSpec;
  }


  private initializeAdaptersFields(): void {
    this.adaptersFields = this.adaptersRtb.map(item => ({
      field: item.field,
      id: item.name,
      config: item.config
    }));
  }

  private mapAdaptersFieldsToFields(): any {
    const fields: any = {};
    this.adaptersFields.forEach(value => {
      fields[value.id] = value.field;
    });

    if (this.isFreewheelAdapter) {
      fields['_indicateToggle'] = this.isFreewheelKeywordsEnabled ? 1 : 0;

      if (this.isFreewheelKeywordsEnabled) {
        const d = this.freewheelKeywordsData;
        fields['timezone'] = d.timezone || null;
        fields['city'] = d.city || null;
        fields['dma'] = d.dma || null;
        fields['state'] = d.state || null;
        fields['programmerBrand'] = d.programmer_brand || null;
        fields['channel'] = d.channel || null;
        fields['genre'] = d.genre || null;
        fields['language'] = d.language || null;
        fields['contentRating'] = d.content_rating || null;
        fields['contentStreamMode'] = d.content_stream_mode || null;

        const validPairs = this.freewheelKeyValuePairs.filter(p => p.key.trim());
        if (validPairs.length > 0) {
          const customObj: Record<string, string> = {};
          validPairs.forEach(p => {
            customObj[this.normalizeFreewheelKey(p.key)] = p.value;
          });
          fields['custom'] = customObj;
        }
      }
    }

    this.fieldsAdapters.push(fields);
    return fields;
  }

  private validateRtbFields(fields: any): void {
    for (const field in fields) {
      if (this.isFieldRequiredAndEmpty(field, fields[field])) {
        this.showNotification('error', 'error', 'error', '', `${field} is required`, '', '', 4500, 'normal');
        this.isDisableSubmit = true;
        return;
      }
    }
  }

  private isFieldRequiredAndEmpty(field: string, fieldValue: any): boolean {
    return this.adaptersItem.config.length && this.adaptersItem.config.paramsReq[field].required && (!fieldValue || fieldValue.length === 0);
  }

  private constructRtbData(fields: any, modifiedSSPList: number[], selectedCountries: string[]): any {
    delete this.formValue.vastConnectionMode;
    const base = {
      ...this.formValue,
      nativeSpec: this.getNativeSpec(),
      connectionType: 0,
      sspList: modifiedSSPList,
      countriesList: selectedCountries,
    };
    return this.fieldsAdapters.length > 0
      ? { ...base, adapter_id: this.formValue.adapter_id, adapter_config: fields }
      : { ...base, adapter_id: this.formValue.adapter_id || 0, adapter_config: null };
  }

  private patchFormValues(): void {
    this.formControls['mobileWeb'].patchValue(this.formValue.jsAdType === 'mobileWeb');
    this.formControls['desktop'].patchValue(this.formValue.jsAdType === 'desktop');
    this.formControls['inApp'].patchValue(this.formValue.jsAdType === 'inApp');
  }

  private constructJsData(modifiedSSPList: number[], selectedCountries: string[]): any {
    return {
      ...this.formValue,
      sspList: modifiedSSPList,
      countriesList: selectedCountries
    };
  }

  private initializePreBidFields(): void {
    this.preBidFields = [];
    this.serverPreBid.map(item => {
      this.preBidFields.push({ field: item.field, id: item.name, config: item.config });
    });
  }

  private constructFieldsFromPreBid(): any {
    const fields = {};
    this.preBidFields.forEach(value => {
      fields[value.id] = value.field;
    });
    return fields;
  }

  private validatePreBidFields(fields: any): void {
    for (const field in fields) {
      if (this.preBidItem !== undefined) {
        if (this.preBidItem.config.length && this.preBidItem.config.paramsReq[field].required && (fields[field] == null || fields[field].length === 0)) {
          this.showNotification('error', 'error', 'error', '', `${field} is required`, '', '', 4500, 'normal');
          this.isDisableSubmit = true;
          return;
        } else if (this.value) {
          this.isDisableSubmit = false;
        }
      }
    }
  }

  private constructPreBidData(fields: any, modifiedSSPList: number[], selectedCountries: string[]): any {
    if (fields) {
      return {
        ...this.formValue,
        adapter_id: this.formValue.adapter_id,
        adapter_config: fields,
        nativeSpec: this.formValue.nativeSpec.includes(-1) ? [1, 2, 3] : this.formValue.nativeSpec,
        connectionType: 4,
        sspList: modifiedSSPList,
        countriesList: selectedCountries
      };
    } else {
      this.isShowFields = false;
      return {
        ...this.formValue,
        adapter_id: this.formValue.adapter_id,
        adapter_config: null,
        nativeSpec: this.formValue.nativeSpec.includes(-1) ? [1, 2, 3] : this.formValue.nativeSpec,
        connectionType: 4,
        sspList: modifiedSSPList,
        countriesList: selectedCountries
      };
    }
  }

  private setSchainCheckboxesState(): void {
    if (!this.partnerSettings?.sellersJson?.contact_domain) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_schain_complete'].enable({ emitEvent: false });
      if (!this.formValue.isSspSchain) {
        this.isShowCustomSchain = false;
        this.isShowCustomSchainFilters = false;
      }
    }
  }

  private processResponseData(resp: PlatformInterface.IResponseDSPById, data: MainDashboardInterface.IEditDSPDialog): void {
    this.setIsDisableBtn(resp);
    this.editDSPForm = this.dynamicFormService.endpointFormWithValues(this.editDSPForm, resp.data, checkboxesForUpdateDSPForm);

    if (this.formValue.dsp_schain_source_file_id) {
      this.isShowSourceFile = true;
      this.formControls['schain_source'].patchValue(true, { emitEvent: false });
      this.getSourceSchainItems('dsp');
    }

    this.updateDeviceIdAndLmtDntFilterState();

    this.updateChainCheckboxesState();

    this.getCompaniesForDropdowns(this.formValue.region, resp.data);

    this.isShowCustomSchain = this.formValue.sChain;
    this.isShowCustomSchainFilters = this.formValue.sChain || this.formValue.isSspSchain || this.formValue.dsp_schain_source_file_id || this.formValue.is_ssp_schain_source;

    if (this.formValue['video'] || this.formValue['rewarded']) {
      this.onChangeVastMacrosesByFormat(true);
    }

    this.updateCountriesItems();

    this.getSchainFilterItems();

    if (this.isRtbConnection() || this.isVastConnection()) {
      this.formControls['endpoint'].addValidators([ErrorValidator.endpointValid]);
      this.formControls['endpoint'].addValidators([Validators.required]);
    }

    if (this.isJSConnection()) {
      const jsControl = this.formControls['spendLimit'];
      if (jsControl) {
        jsControl.addValidators([Validators.required]);
      }

      const jsWControl = this.editDSPForm.get('js')?.get('w');
      if (jsWControl) {
        jsWControl.addValidators([Validators.required]);
      }

      const jsHControl = this.editDSPForm.get('js')?.get('h');
      if (jsHControl) {
        jsHControl.addValidators([Validators.required]);
      }

      const jsCpmControl = this.editDSPForm.get('js')?.get('cpm');
      if (jsCpmControl) {
        jsCpmControl.addValidators([Validators.required]);
      }

      const limitQPSControl = this.formControls['limitQPS'];
      if (limitQPSControl) {
        limitQPSControl.addValidators([Validators.required]);
      }
    }


    const isSelectedBanner = this.formValue.banner;
    const isSelectedVideo = this.formValue.video;
    const isSelectedRewarded = this.formValue.rewarded;
    const isSelectedNative = this.formValue.native;

    if (isSelectedBanner) {
      this.onChangeBannerFormatHandler(true);
    }

    if (isSelectedVideo) {
      this.onChangeVideoFormatHandler(true);
    }

    if (isSelectedRewarded) {
      this.onChangeRewardedVideoFormatHandler(true);
    }

    if (isSelectedNative) {
      this.onChangeNativeHandler(true);
    }


    this.onChangeVideoWidthPresetsHandler(this.formValue.presetPlayerSizes.size);
    this.onChangeVideoSizesHandler(this.formValue.playerSizes.size);

    this.setMarginOnInit(resp);

    this.formControls['margin'].patchValue(resp.data.margin);

    if (resp.data.pixalate_pb_settings) {
      this.updatePixalatePBSettingsGroup(resp.data.pixalate_pb_settings);
    }

    if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
      this.formControls['is_dual_schain']?.disable({ emitEvent: false });
      this.formControls['is_dual_schain']?.patchValue(false, { emitEvent: false });
    }

    this.updatePchainFormControl();

    if (this.isJSConnection()) {
      this.isShowBannerSizes = true;
    }

    this.patchVastConnectionMode();
    this.modifyFilterListsArray(data);
    this.setNativeSpec();
    this.setArrayOfMargins();
    this.setBannerSizeListArray();
    this.setVideoSizeListArray();
    this.processConnectionTypes(resp);
    this.handleVast();
  }

  private updateCountriesItems(): void {
    const regionMappings: { label: string; keys: string[] }[] = [
      { label: 'Caribbean', keys: this.options.getCaribbeanCountriesKeysList() },
      { label: 'NA', keys: this.options.getNorthAmericaCountriesKeysList() },
      { label: 'LATAM', keys: this.options.getLATAMCountriesKeysList() },
      { label: 'EU', keys: this.options.getEuropeCountriesKeysList() },
      { label: 'MENA', keys: this.options.getMENACountriesKeysList() },
      { label: 'SSA', keys: this.options.getSSACountriesKeysList() },
      { label: 'APAC', keys: this.options.getAPACCountriesKeysList() },
      { label: 'Other', keys: this.options.getOtherCountriesKeysList() },
    ];

    const selectedCountries: string[] = this.formValue.countriesList ?? [];

    const regionLabelsToAdd = regionMappings
      .filter(region => region.keys.every(key => selectedCountries.includes(key)))
      .map(region => region.label)
      .filter(label => !selectedCountries.includes(label));

    if (regionLabelsToAdd.length) {
      const updatedCountries = Array.from(new Set([...selectedCountries, ...regionLabelsToAdd]));
      this.editDSPForm.get('countriesList')?.patchValue(updatedCountries);
    }
  }

  private getSelectedCountriesList(selectedKeys: string[]): string[] {
    // Helper-map that links a shortcut with the resolver that provides its countries list.
    const regionResolvers: Record<string, () => string[]> = {
      Caribbean: () => this.options.getCaribbeanCountriesKeysList(),
      NA: () => this.options.getNorthAmericaCountriesKeysList(),
      LATAM: () => [
        ...this.options.getLATAMCountriesKeysList(),
        ...this.options.getCaribbeanCountriesKeysList(),
      ],
      EU: () => this.options.getEuropeCountriesKeysList(),
      MENA: () => this.options.getMENACountriesKeysList(),
      SSA: () => this.options.getSSACountriesKeysList(),
      APAC: () => this.options.getAPACCountriesKeysList(),
      Other: () => this.options.getOtherCountriesKeysList(),
    };

    const result = new Set<string>(selectedKeys);

    Object.entries(regionResolvers).forEach(([shortcut, resolver]) => {
      const shortcutSelected = result.has(shortcut);
      const countries = resolver();

      if (shortcutSelected) {
        // Add all countries from the shortcut and remove the shortcut itself.
        countries.forEach(code => result.add(code));
        result.delete(shortcut);
      }
    });

    return Array.from(result);
  }

  private setIsDisableBtn(resp: PlatformInterface.IResponseDSPById): void {
    const restrictedConnectionTypes = [4];
    this.isDisableSubmit = !!resp.data.deletedAt || (this.partner?.partner_plan === 3 && restrictedConnectionTypes.includes(resp.data.connectionType));

    const restrictionRegions = ['APAC', 'EU'];
    if (restrictionRegions.includes(resp.data.region) && this.partner?.partner_plan === 3) {
      this.isDisableSubmit = true;
      this.isDisableDuplicate = true;
    }
  }

  private updateSSPDropdown(data: PlatformInterface.IPlatformDSP): void {
    if (this.companiesSSPDropdown.length) {
      const updatedCompanies = this.getUpdatedCompanies(data.sspList as number[]);
      this.companiesSSPDropdown = JSON.parse(JSON.stringify(updatedCompanies));
      const modifiedSspList = getStringCheckedKeys(this.companiesSSPDropdown);
      this.editDSPForm.get('sspList')?.patchValue(modifiedSspList);
    }
  }

  private getUpdatedCompanies(dspList: number[]): any[] {
    const arrayCompanies = JSON.parse(JSON.stringify(this.companiesSSPDropdown));
    const updatedCompanies = updateCheckedStatus([...arrayCompanies], dspList);
    return rearrangeCompaniesItems([...updatedCompanies], dspList);
  }

  private patchVastConnectionMode(): void {
    this.getVastMacroses();
  }

  private processConnectionTypes(resp: PlatformInterface.IResponseDSPById): void {
    if (this.isPreBidConnection()) {
      this.processPreBidConnection(resp);
    }

    if (this.isRtbConnection()) {
      this.processRtbConnection(resp);
    }

    if (this.isJSConnection()) {
      this.handleJS();
    }
  }

  private processPreBidConnection(resp: PlatformInterface.IResponseDSPById): void {
    this.getDSPAdapterForPrebid(resp);

    this.onResolveAdapterFieldsHandler();
  }

  private onSetServerPreBid(resp: PlatformInterface.IResponseDSPById): void {
    if (resp.data.adapter_config) {
      const object = resp?.data?.adapter_config ? JSON.parse(resp.data.adapter_config) : null;
      const array = Object.entries(object);
      this.serverPreBid = array.map((item, index) => {
        return {
          name: item[0],
          field: item[1],
          id: index++,
          tooltip: this.preBidItem.config.paramsReq[item[0]].tooltip ?? null,
          type: this.preBidItem.config.paramsReq[item[0]].type ?? 'string',
        };
      });

      this.updateShowFieldsStatus();
    }
  }

  private processRtbConnection(resp): void {
    if (!this.formValue.adapter_id) {
      this.formControls['adapter_id'].patchValue(0);
    }
    this.getDSPAdaptersForRtb(resp);
  }

  private updateShowFieldsStatus(): void {
    this.isShowFields = this.serverPreBid.length > 0 || this.adaptersRtb.length > 0;
  }

  private updatePixalatePBSettingsGroup(data: PlatformInterface.IEndpointPixalatePreBidSettings) {
    this.editDSPForm.get('pixalate_pb_settings')?.patchValue({
      ip: data.ip === 1,
      ip_percent: data.ip === 1 ? data.ip_percent : 0,
      ifa: data.ifa === 1,
      ua: data.ua === 1,
      ua_percent: data.ua === 1 ? data.ua_percent : 0,
      ott: data.ott === 1,
      ott_percent: data.ott === 1 ? data.ott_percent : 0,
      def_app: data.def_app === 1,
      def_app_percent: data.def_app === 1 ? data.def_app_percent : 0,
      domain: data.domain === 1,
      domain_percent: data.domain === 1 ? data.domain_percent : 0,
      hr_app: data.hr_app === 1,
      hr_app_percent: data.hr_app === 1 ? data.hr_app_percent : 0,
      dc_subnet: data.dc_subnet === 1,
      dc_subnet_percent: data.dc_subnet === 1 ? data.dc_subnet_percent : 0,
    });
  }

  private modifyReqData(removedFields: string[], checkboxes: string[], reqObject: { [key: string]: any }): { [key: string]: any } {
    let requestBody: { [key: string]: any } = {};
    for (const key of Object.keys(reqObject)) {
      if (key !== 'adapter_config') {
        if (removedFields.includes(key) || reqObject[key] === null || reqObject[key] === undefined) {
          delete reqObject[key];
          continue;
        }
      }


      if (checkboxes.includes(key)) {
        reqObject[key] = reqObject[key] ? 1 : 0;
        continue;
      }

      if (key === 'pixalate_pb_settings' && typeof reqObject[key] === 'object') {
        for (const innerKey of Object.keys(reqObject[key])) {
          if (checkboxes.includes(innerKey)) {
            const innerValue = reqObject[key][innerKey];
            reqObject[key][innerKey] = innerValue ? 1 : 0;
          }
        }
      }
    }

    requestBody = { ...reqObject };

    return requestBody;
  }

  private removeUnnecessaryFormValues(): void {
    delete this.formValue.rtbConnectionMode;
    delete this.formValue.vastConnectionMode;
  }

  private handleSuccessResponse(resp: any, callback: (type: string) => void): void {
    this.showNotification('success', 'success', 'success', 'DSP', resp.data.name, 'updated', '', 4500, 'bold');
    this.isDisableSubmit = false;
    this.tabIndex = 0;
    this.editDSPForm.reset({}, { emitEvent: false });
    this.adaptersFields = [];
    this.serverPreBid = [];
    this.serversPreBid = [];
    this.adaptersRtb = [];
    callback('updated');
  }

  private handleErrorResponse(err: any): void {
    this.isDisableSubmit = false;
    if (err.errors.global.hasOwnProperty('has_rubicon_settings') && err.errors.global.has_rubicon_settings.includes(false)) {
      this.showRubiconErrorNotification();
      this.isDisabledRubiconOption = true;
    } else {
      this.handleError(err);
    }
  }

  private initPartnerSettings(data: MainDashboardInterface.IEditDSPDialog): void {
    this.partnerSettings = data.partnerSettings;

    if (!this.partnerSettings.is_authorized_schain) {
      this.formControls['is_authorized_schain'].disable({ emitEvent: false });
    } else {
      this.updateIsAuthorizedSchainControlState();
    }

    if (this.partnerSettings.is_source_schain) {
      this.getExistingSourceSchainInfo();
    } else {
      this.formControls['schain_source'].patchValue(null, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }
  }

  private initializeData(data: MainDashboardInterface.IEditDSPDialog) {
    this.tabIndex = 0;
    this.userRole = this.auth.userRole;
    this.endpointId = data.endpointId;
    this.osList = data.osList;
    this.rtbVersions = data.rtbVersions;
    this.schaninNodeLimitItems = data.schaninNodeLimitItems;
    this.companies = data.companies.filter(company => company.id !== -1);
    this.regions = this.mainService.regions;
    this.secureOptions = this.options.getSecureOptions();
    this.listOfSizes = this.options.getListOfSizes();
    this.nurlOptions = this.options.getNurlOptions();
    this.statesList = data.statesList ? [...data.statesList] : [];
    this.countriesItems = this.options.getCountriesItems();
    this.sizesList = this.options.getSizesList();
    this.videoSizesList = this.options.getVideoSizesList();
    this.pornFilter = this.options.getPornFilter();
    this.connectionTypes = this.options.getConnectionTypes();
    this.isRequiredCompany = false;
    this.isRequiredRegion = false;
    this.isRequiredAdFormat = false;
    this.isRequiredTrafficType = false;
    this.partner = this.auth.partner;
  }

  private initializePartnerSpecificSizes() {
    const partnerSpecificSizes = {
      23: [{ id: '768x1024', name: '768x1024' }],
      10: [
        { id: '350x196', name: '350x196' },
        { id: '768x1024', name: '768x1024' },
        { id: '728x1280', name: '728x1280' },
      ],
    };

    const sizesToAdd = partnerSpecificSizes[this.partner.id];
    if (sizesToAdd) {
      this.sizesList.push(...sizesToAdd);
    }
  }

  private fetchInitialData(data: MainDashboardInterface.IEditDSPDialog) {
    this.getEndpointById(data);
    this.getEndpoints();
    this.getAdServers();
  }

  private isValidSizeInput(value: string): boolean {
    const reg = /[^x0-9]+/;
    return this.isValidInput(value, 'x', reg);
  }

  private isValidInput(value: string, separator: string, reg: RegExp): boolean {
    const arrayString = value.split(separator);
    return (
      value.includes(separator) &&
      arrayString[0].length > 0 &&
      arrayString[1].length > 0 &&
      !reg.test(value)
    );
  }

  private showSizeNotAllowedNotification(): void {
    this.showNotification('error', 'error', 'error', '', 'Size not allowed', '', '', 4500, 'normal');
  }

  private addSizeToArrayIfUnique(value: string, array: any[]): boolean {
    const arrayWithNames = array.map(element => element['name']);
    if (!arrayWithNames.includes(value)) {
      array.push({ id: value, name: value });
      return true;
    }
    return false;
  }

  private resetPreBidFields(): void {
    this.preBidFields = [];
  }

  private findPreBidItem(server: string | number): void {
    const foundItem = this.preBidServers.find(item => item.id === server);
    if (foundItem) {
      this.preBidItem = foundItem;
    }
  }

  private configureServerPreBid(server: string | number): void {
    if (server === this.adapter_id) {
      this.configureForAdapterId();
    } else if (this.preBidItem) {
      this.configureForPreBidItem();
    }
  }

  private configureForAdapterId(): void {
    const object = JSON.parse(this.formValue.adapter_config);
    const array = Object.entries(object);
    this.serverPreBid = array.map(([name, field], index) => ({ name, field, id: index, tooltip: this.preBidItem.config.paramsReq[name].tooltip ?? null, type: this.preBidItem.config.paramsReq[name].type ?? 'string' }));
  }

  private configureForPreBidItem(): void {
    this.serverPreBid = this.preBidItem.fields.map(item => ({
      name: item,
      field: null,
      id: item,
      config: item,
      tooltip: this.preBidItem.config.paramsReq[item].tooltip,
      type: this.preBidItem.config.paramsReq[item].type ?? 'string'
    }));

  }

  private processAdapterConfig(): void {
    const object = JSON.parse(this.formValue.adapter_config);
    this.adaptersRtb = Object.entries(object).map(([name, field], index) => ({
      name,
      field,
      id: index,
    }));
  }

  private processRtbServer(): void {
    if (!this.adaptersItem) {
      this.adaptersRtb = [];
      return;
    }

    if (this.adaptersItem.fields.length > 0) {
      const paramsReq = this.adaptersItem.config?.paramsReq ?? {};

      const toggleChildren = new Set<string>();
      for (const key of Object.keys(paramsReq)) {
        const param = paramsReq[key];
        if (param?.type === 'toggle' && Array.isArray(param.children)) {
          param.children.forEach((child: string) => toggleChildren.add(child));
        }
      }

      const visibleFields = this.adaptersItem.fields.filter((item: string) => {
        const param = paramsReq[item];
        return param?.type !== 'toggle' && param?.type !== 'object' && !toggleChildren.has(item);
      });

      this.adaptersRtb = visibleFields.map((item: string) => ({
        name: item,
        field: null,
        id: item,
        config: item,
        parentName: this.adaptersItem.name,
        tooltip: paramsReq[item]?.tooltip ?? null,
        disabled: false,
      }));
    } else {
      this.adaptersRtb = [];
    }

    this.isShowFields = this.adaptersRtb.length > 0;
  }

  private disableSubmitButton(): void {
    this.isDisableSubmit = true;
  }

  private validateForm(): boolean {
    if (!this.handleErrors()) {
      this.isDisableSubmit = false;
      return false;
    }
    return true;
  }

  private prepareFormForSubmission(): void {
    this.setMargin();
    this.removeMinRcpmIfNotUsingAdapter();
  }

  private removeMinRcpmIfNotUsingAdapter(): void {
    if (!this.formValue.useAdapter) {
      if (this.editDSPForm.contains('min_rcpm')) {
        this.editDSPForm.removeControl('min_rcpm');
      }
    }
  }

  private submitFormBasedOnConnectionType(callback: (type: string) => void): void {
    const modifiedSSPList = [...getEndpointsCheckedKeys(this.companiesSSPDropdown)];
    const selectedCountries = this.getSelectedCountriesList(this.formValue.countriesList);


    const isPresentStates = selectedCountries.includes('USA');


    if (!isPresentStates) {
      this.formControls['statesList'].patchValue([]);
      this.formControls['is_undefined_state_allowed'].patchValue(false);
    }

    switch (this.formValue.connectionType) {
      case 0:
        this.submitRtb(modifiedSSPList, callback, selectedCountries);
        break;
      case 1:
        this.submitVast(modifiedSSPList, callback, selectedCountries);
        break;
      case 3:
        this.submitJS(modifiedSSPList, callback, selectedCountries);
        break;
      case 4:
        this.submitPreBid(modifiedSSPList, callback, selectedCountries);
        break;
    }
  }

  private openDeleteConfirmationDialog(endpoint: PlatformInterface.IPlatformDSP): NzModalRef {
    return this.modalService.create({
      nzContent: DeleteEndpointConfirmComponent,
      nzStyle: { top: '200px', width: '450px', height: '170px' },
      nzBodyStyle: { width: '450px', height: '170px' },
      nzClassName: 'delete-endpoint-modal',
      nzWrapClassName: 'delete-endpoint-modal-wrap',
      nzClosable: false,
      nzMaskClosable: false,
      nzData: {
        entity: 'endpoint', name: endpoint.name,
      }
    });
  }

  private handleDeleteSuccess(callback: (type: string) => void): void {
    this.showNotification('success', 'success', 'success', '', 'Endpoint deleted!', '', '', 4500, 'normal');
    callback('updated');
    this.modalService.closeAll();
  }

  private duplicateEndpoint(endpointId: number): Observable<any> {
    return this.mainService.duplicateEndpointReq(endpointId, 'dsp');
  }

  private handleDuplicateSuccess(callback: (type: string) => void): void {
    this.showNotification('success', 'success', 'success', '', 'Endpoint is duplicated!', '', '', 4500, 'normal');
    callback('updated');
    this.modalService.closeAll();
  }

  private showLoading(): void {
    this.loadingService.show();
  }

  private hideLoading(): void {
    this.loadingService.hide();
  }

  private handleError(error: any): void {
    this.errorsHandlingService.handleError(error);
  }

  private updateChainCheckboxesState(): void {
    this.isShowCustomSchain = this.formValue.sChain;
    this.isShowCustomSchainFilters = this.formValue.sChain || this.formValue.isSspSchain || this.formValue.schain_source;
    if (this.formValue['schain_source']) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue['is_ssp_schain_source']) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue['sChain']) {
      this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (this.formValue['isSspSchain']) {
      this.formControls['sChain'].patchValue(false, { emitEvent: false });
      this.formControls['schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
      this.formControls['sChain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    }

    if (!this.formValue['isSspSchain'] || !this.formValue['sChain'] || !this.formValue['schain_source'] || !this.formValue['is_ssp_schain_source']) {
      this.formControls['is_schain_complete']?.disable({ emitEvent: false });
      this.formControls['is_dual_schain']?.disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source']?.enable({ emitEvent: false });
    }

    if (this.formValue['isSspSchain'] || this.formValue['sChain'] || this.formValue['schain_source'] || this.formValue['is_ssp_schain_source']) {
      this.formControls['is_schain_complete']?.enable({ emitEvent: false });
      this.formControls['is_dual_schain']?.enable({ emitEvent: false });
    }

    if (this.formValue['is_ssp_schain_source']) {
      this.formControls['schain_source'].disable({ emitEvent: false });
    }

    if (!this.formValue['is_ssp_schain_source']) {
      this.formControls['schain_source'].enable({ emitEvent: false });
    }


    this.setSchainCheckboxesState();
    this.updateFormControlsBasedOnPartnerPlan();
  }

  private updateFormControlsBasedOnPartnerPlan(): void {
    if (this.partner?.partner_plan !== 1 && this.partner?.partner_plan !== 2) {
      this.formControls['schain_filter_option'].disable({ emitEvent: false });
      this.formControls['schain_complete_option'].disable({ emitEvent: false });
      this.formControls['schain_limit'].disable({ emitEvent: false });
    } else if (this.partner?.partner_plan === 1 || this.partner?.partner_plan === 2) {
      if (this.formValue['schain_source']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['is_ssp_schain_source']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['sChain']) {
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['isSspSchain']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['isSspSchain'] || this.formValue['sChain'] || this.formValue['schain_source'] || this.formValue['is_ssp_schain_source']) {
        this.formControls['is_schain_complete'].enable({ emitEvent: false });
        this.formControls['is_dual_schain'].enable({ emitEvent: false });
      } else {
        this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
        this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
        this.formControls['is_schain_complete'].disable({ emitEvent: false });
        this.formControls['is_dual_schain'].disable({ emitEvent: false });
      }

      if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
        this.formControls['is_dual_schain'].disable({ emitEvent: false });
        this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      }
    }

    if (this.partner?.partner_plan !== 1) {
      this.formControls['isSspSchain'].disable({ emitEvent: false });
      this.formControls['schain_source'].disable({ emitEvent: false });
      this.formControls['schainCompany'].disable({ emitEvent: false });
      this.formControls['is_requests_empty_appname'].disable({ emitEvent: false });
      this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
    } else {
      if (this.formValue['schain_source']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['is_ssp_schain_source']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['sChain']) {
        this.formControls['isSspSchain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['isSspSchain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['isSspSchain']) {
        this.formControls['sChain'].patchValue(false, { emitEvent: false });
        this.formControls['schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['sChain'].disable({ emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.formValue['isSspSchain'] || this.formValue['sChain'] || this.formValue['schain_source'] || this.formValue['is_ssp_schain_source']) {
        this.formControls['is_schain_complete'].enable({ emitEvent: false });
        this.formControls['is_dual_schain'].enable({ emitEvent: false });
      } else {
        this.formControls['is_schain_complete'].patchValue(false, { emitEvent: false });
        this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
        this.formControls['is_schain_complete'].disable({ emitEvent: false });
        this.formControls['is_dual_schain'].disable({ emitEvent: false });
      }

      if (this.sspFileCnt === 0) {
        this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
        this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
      }

      if (this.dspFileCnt === 0) {
        this.formControls['schain_source'].patchValue(null, { emitEvent: false });
        this.formControls['schain_source'].disable({ emitEvent: false });
      }


      if (this.formValue.adapter_id !== 0 && this.formValue.adapter_id !== null) {
        this.formControls['is_dual_schain'].disable({ emitEvent: false });
        this.formControls['is_dual_schain'].patchValue(false, { emitEvent: false });
      }
    }

    this.updateIsAuthorizedSchainControlState();
  }

  private updateIsAuthorizedSchainControlState(): void {
    if (!this.formControls['is_authorized_schain']) {
      return;
    }

    if (!this.formValue['sChain']) {
      this.formControls['is_authorized_schain'].patchValue(false, { emitEvent: false });
      this.formControls['is_authorized_schain'].disable({ emitEvent: false });
    } else {
      if (this.partnerSettings?.is_authorized_schain) {
        this.formControls['is_authorized_schain'].enable({ emitEvent: false });
      } else {
        this.formControls['is_authorized_schain'].disable({ emitEvent: false });
      }
    }
  }

  private updatePchainFormControl(): void {
    if (this.formValue.isSspSchain || this.formValue.sChain || this.formValue.is_ssp_schain_source || this.formValue.schain_source) {
      this.formControls['is_pchain'].enable({ emitEvent: false });
    } else {
      this.formControls['is_pchain'].disable({ emitEvent: false });
      this.formControls['is_pchain'].patchValue(false, { emitEvent: false });
    }
  }

  private updateDeviceIdAndLmtDntFilterState(): void {
    try {
      const deviceIdRequired = this.formValue?.deviceIdRequired;
      const isLmtAndDntFilter = this.formValue?.is_lmt_and_dnt_filter;

      const deviceIdControl = this.formControls['deviceIdRequired'];
      const lmtDntControl = this.formControls['is_lmt_and_dnt_filter'];


      if (deviceIdRequired) {
        lmtDntControl.disable({ emitEvent: false });
      } else {
        lmtDntControl.enable({ emitEvent: false });
      }

      // If is_lmt_and_dnt_filter is true, disable deviceIdRequire
      if (isLmtAndDntFilter) {
        deviceIdControl.disable({ emitEvent: false });
      } else {
        deviceIdControl.enable({ emitEvent: false });
      }
    } catch (error) {
      console.error('Error updating deviceIdRequired and is_lmt_and_dnt_filter state:', error);
    }
  }

  private getVastMacroses(): void {
    this.listOfMacros = [];
    this.listOfMacros = this.macrosListVast.map(macros => macros);
    this.listOfMacros.push(
      {
        id: '[IP]',
        name: '[IP]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'IPv4 address closest to device',
      },
    );
    this.listOfMacros.push(
      {
        id: '[UA]',
        name: '[UA]',
        mobile_web: false,
        desktop: false,
        mobile_app: false,
        ctv: false,
        desc: 'Browser user agent string.',
      },
    );
  }

  public onEndpointUrlTestHandler(endpointUrl: string, event: MouseEvent): void {
    event.preventDefault();
    this.endpointUrl = endpointUrl;
  }

  private onChangeVastMacrosesByFormat(value: boolean): void {
    if (value) {
      this.macrosListVast = this.macrosListVast.filter(item => item.id !== '[FEED]');
    } else {
      this.macrosListVast = defaultMacrosListVast;
    }
    this.listOfMacros = this.macrosListVast.map(macros => macros);
  }

  private createForm(): void {
    this.editDSPForm = this.dynamicFormService.createEditDSPForm();
    this.formControls['name'].addValidators([ErrorValidator.cannotContainSpace]);
  }

  private modifyFilterListsArray(data: MainDashboardInterface.IEditDSPDialog): void {
    const filterLists = data.filterLists;
    this.filterLists = rearrangeFilterListItems(filterLists, this.formValue.filter_list_ids);
  }

  private showRubiconErrorNotification(): void {
    this.showNotification(
      'error',
      'error',
      'adapter-error',
      'Credentials are required for Rubicon API adapter setup. Please fill in Rubicon credentials in the',
      'Platform settings ',
      'section first, then you will be able to create an endpoint with Rubicon API adapter configuration.',
      '450px',
      10000,
      'bold',
    );
  }

  private showNotification(
    iconType: string,
    color: string,
    notificationType: string,
    leftPartOfText: string,
    description: string,
    rightPartOfText: string,
    width: string,
    duration: number,
    fontWeight: string,
  ): void {
    const data = {
      iconType,
      color,
      notificationType,
      description,
      leftPartOfText: leftPartOfText ?? '',
      rightPartOfText: rightPartOfText ?? '',
      fontWeight: fontWeight ?? 'normal',
    };

    this.notificationComponent.data = data;
    this.notificationService.showTemplate({
      nzData: data,
      nzStyle: { width: width ?? '385px' },
      nzDuration: duration ?? 4500,
    });
  }


  private submitVast(modifiedSSPList: number[], callback: (type: string) => void, selectedCountries: string[]): void {
    this.patchFormControlsBasedOnAdType();
    delete this.formValue.rtbConnectionMode;

    const vastData = this.prepareVastData(modifiedSSPList, selectedCountries);
    this.updateVastEndpoint(vastData, callback);
  }

  private updateVastEndpoint(vastData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedVastDSPFields, vastDSPCheckboxes, vastData), 'dsp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err)
      );
  }

  private submitRtb(modifiedSSPList: number[], callback: (type: string) => void, selectedCountries: string[]): void {
    this.initializeAdaptersFields();
    const fields = this.mapAdaptersFieldsToFields();
    this.validateRtbFields(fields);

    const rtbData = this.constructRtbData(fields, modifiedSSPList, selectedCountries);
    this.updateRtbEndpoint(rtbData, callback);
  }

  private updateRtbEndpoint(rtbData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedRtbDSPFields, rtbDSPCheckboxes, rtbData), 'dsp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err),
      );
  }

  private submitJS(modifiedSSPList: number[], callback: (type: string) => void, selectedCountries: string[]): void {
    this.patchFormValues();
    this.removeUnnecessaryFormValues();

    const jsData = this.constructJsData(modifiedSSPList, selectedCountries);
    this.updateJSEndpoint(jsData, callback);
  }

  private updateJSEndpoint(jsData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedJsDSPFields, jsDSPCheckboxes, jsData), 'dsp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err)
      );
  }

  private submitPreBid(modifiedSSPList: number[], callback: (type: string) => void, selectedCountries: string[]): void {
    this.initializePreBidFields();
    const fields = this.constructFieldsFromPreBid();
    this.validatePreBidFields(fields);

    this.removeUnnecessaryFormValues();
    const preBidData = this.constructPreBidData(fields, modifiedSSPList, selectedCountries);
    this.updatePreBidEndpoint(preBidData, callback);
  }

  private updatePreBidEndpoint(preBidData: any, callback: (type: string) => void): void {
    this.mainService.updateEndpointById(this.endpointId, this.modifyReqData(removedPreBidDSPFields, preBidDSPCheckboxes, preBidData), 'dsp')
      .subscribe(
        resp => this.handleSuccessResponse(resp, callback),
        err => this.handleErrorResponse(err)
      );
  }

  private getEndpointById(data: MainDashboardInterface.IEditDSPDialog): void {
    this.showLoading();
    this.mainService.getDSP(data.endpointId)
      .pipe(finalize(() => this.hideLoading()))
      .subscribe(
        (resp: PlatformInterface.IResponseDSPById) => {
          this.processResponseData(resp, data);
        },
        err => this.handleError(err));
  }

  private getDSPAdapterForPrebid(resp: PlatformInterface.IResponseDSPById): void {
    this.mainService.getAdaptersByType({ is_prebid: true, type: 'dsp' })
      .subscribe({
        next: (res) => {
          this.preBidServers = res;
          this.serversPreBid = this.preBidServers.map(({ id, name, config }) => ({ id, name, config }));
          this.preBidItem = res.find(item => item.id === this.formValue.adapter_id);

          this.onSetServerPreBid(resp);
        },
        error: (error) => this.handleError(error)
      });
  }

  private getDSPAdaptersForRtb(endpointData: PlatformInterface.IResponseDSPById): void {
    this.showLoading();
    this.fetchAdapters()
      .pipe(finalize(() => this.hideLoading()))
      .subscribe({
        next: (res) => this.processAdapters(res, endpointData),
        error: (error) => this.handleError(error)
      });
  }

  private getAdServers(): void {
    this.mainService.getAdServers()
      .subscribe(resp => {
        this.adServers = resp.data;
        this.servers = this.adServers
          .filter(item => item.adTypes && item.adTypes[this.formValue.adtype])
          .map(({ id, name }) => ({ id, name }));
      },
        error => this.handleError(error));
  }

  private getEndpoints(): void {
    this.mainService.getEndpointItemsReq()
      .subscribe(data => {
        this.sspList = data.ssp;
      },
        error => this.handleError(error));
  }

  private getSchainFilterItems(): void {
    this.mainService.getFilterValuesByKeyReq({ filters: ['schainNodesFilter', 'schainValues'] })
      .subscribe((res: { schainNodesFilter: { id: number; name: string }[], schainValues: SelectItemsInterface.ISchainValue[] }) => {
        this.schainNodesFilters = res.schainNodesFilter;
        this.schainValues = res.schainValues;

        if (this.formValue.schainCompany !== 1 && this.formValue.schain_node_order && this.formValue.sChain) {
          this.updateSchainNodeOrderItems(this.formValue.schainCompany);
          this.isShowSchainNodeOrder = true;
        }

      }, error => this.handleError(error));
  }


  private deleteEndpoint(endpoint: PlatformInterface.IPlatformDSP, callback: (type: string) => void): void {
    this.showLoading();
    this.mainService.deleteEndpointReq(endpoint.id, 'dsp')
      .pipe(finalize(() => this.hideLoading()))
      .subscribe(
        () => {
          this.handleDeleteSuccess(callback);
        },
        error => this.handleError(error)
      );
  }

  private getExistingSourceSchainInfo(): void {
    this.sourceSchainService.onGetExistingSourceSchainRequest()
      .subscribe(res => {
        this.sspFileCnt = res.sspFileCnt;
        this.dspFileCnt = res.dspFileCnt;


        if (this.sspFileCnt === 0) {
          this.formControls['is_ssp_schain_source'].patchValue(false, { emitEvent: false });
          this.formControls['is_ssp_schain_source'].disable({ emitEvent: false });
        }


        if (this.dspFileCnt === 0) {
          this.formControls['schain_source'].patchValue(null, { emitEvent: false });
          this.formControls['schain_source'].disable({ emitEvent: false });
        }
      },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getSourceSchainItems(type: string): void {
    this.sourceSchainService.getSourceSchainListReq(type)
      .subscribe(res => {
        this.sourceSchainItems = res.data;
      },
        error => this.errorsHandlingService.handleError(error)
      );
  }

  private getCompaniesForDropdowns(region: string, data: PlatformInterface.IPlatformDSP): void {
    this.getCompaniesForDropdownsReq(region).subscribe(res => {
      this.companiesSSPDropdown = transformArray(res.ssp);

      this.updateSSPDropdown(data);
    },
      error => this.errorsHandlingService.handleError(error));
  }

  private getCompaniesForDropdownsReq(region: string): Observable<MainDashboardInterface.CompaniesDataRes> {
    const params = new HttpParams().append('without_deleted', true);

    return this.http.get<MainDashboardInterface.CompaniesDataRes>(`${this.apiUrl}/endpoints/grouped-by-company/ssp/${region}`, { params: params })
      .pipe(map(res => {
        res.ssp = res.ssp.map(company => {
          company.endpoints = company.endpoints.map(endpoint => {
            return { checked: false, disabled: false, label: endpoint.name, value: endpoint.id, ...endpoint };
          });
          return { checked: false, label: company.name, value: company.id, indeterminate: false, ...company };
        });

        return res;
      }),
        catchError(this.errorsHandlingService.processError));
  }
}
